<ngx-spinner></ngx-spinner>

<div class="row text-left">
  <div class="col-12 px-0 px-md-2">
    <div class="card screen-main-card">
      <div class="card-body px-0 px-md-3">
        <form
          novalidate
          [formGroup]="trainingForm"
          (submit)="onSubmit()"
          class="d-flex flex-column justify-content-center align-items-center flex-grow-1 position-relative"
        >
          <div class="position-absolute form-action-buttons px-1 px-md-0">
            <button
              type="submit"
              title="Salvar edição"
              class="btn btn-primary px-2 mr-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.9124 0.41626C13.3041 0.41626 13.6799 0.5719 13.9569 0.848951L16.0461 2.93815C16.3232 3.2152 16.4788 3.59095 16.4788 3.98275V14.4505C16.4788 15.6744 15.4868 16.6664 14.2629 16.6664H2.44457C1.22075 16.6664 0.228638 15.6744 0.228638 14.4505V2.63219C0.228638 1.40837 1.22075 0.41626 2.44457 0.41626H12.9124ZM2.44457 1.89355C2.03663 1.89355 1.70593 2.22426 1.70593 2.63219V14.4505C1.70593 14.8585 2.03663 15.1892 2.44457 15.1892H3.18322V10.7573C3.18322 9.53343 4.17533 8.54135 5.39915 8.54135H11.3083C12.5322 8.54135 13.5242 9.53343 13.5242 10.7573V15.1892H14.2629C14.6708 15.1892 15.0015 14.8585 15.0015 14.4505V4.7214C15.0015 4.32959 14.8459 3.95384 14.5688 3.67679L13.2183 2.32624C12.9412 2.04919 12.5655 1.89355 12.1737 1.89355H12.047V3.37084C12.047 4.59466 11.0549 5.58677 9.83102 5.58677H6.87644C5.65262 5.58677 4.66051 4.59466 4.66051 3.37084V1.89355H2.44457ZM12.047 15.1892V10.7573C12.047 10.3493 11.7163 10.0186 11.3083 10.0186H5.39915C4.99121 10.0186 4.66051 10.3493 4.66051 10.7573V15.1892H12.047ZM6.1378 1.89355H10.5697V3.37084C10.5697 3.77878 10.239 4.10948 9.83102 4.10948H6.87644C6.4685 4.10948 6.1378 3.77878 6.1378 3.37084V1.89355Z"
                  fill="white"
                />
              </svg>
            </button>
            <!-- <button
              type="button"
              title="Compartilhar treino"
              class="btn btn-primary px-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M7.16689 9.41227L15.3345 1.24771M7.39906 9.77944L9.25105 13.4835C9.69864 14.3786 9.92239 14.8262 10.2043 14.9462C10.449 15.0504 10.7286 15.0314 10.9571 14.8954C11.2204 14.7387 11.3821 14.2651 11.7055 13.318L15.2047 3.07014C15.4866 2.24493 15.6274 1.83232 15.531 1.55937C15.4471 1.32192 15.2603 1.13514 15.0229 1.05125C14.7499 0.954814 14.3373 1.09571 13.5121 1.37748L3.26416 4.87677C2.31709 5.20016 1.84355 5.36186 1.68679 5.62512C1.55075 5.85358 1.5319 6.13325 1.63605 6.37786C1.75606 6.65977 2.20362 6.88361 3.09874 7.33111L6.80278 9.18319C6.95031 9.25694 7.02406 9.29377 7.08789 9.34302C7.14464 9.38677 7.19547 9.43761 7.23914 9.49427C7.28847 9.55819 7.32531 9.63194 7.39906 9.77944Z"
                  stroke="white"
                  stroke-width="1.53846"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button> -->
          </div>

          <div class="w-100 px-1 px-md-0">
            <div class="w-100 d-flex justify-content-center align-items-start">
              <div class="w-100 promotion-time-left-block">
                <div
                  class="card border shadow-card w-100 d-flex flex-row justify-content-center align-items-center px-1 px-md-3 py-2 m-0"
                >
                  <div class="position-relative h-fit">
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 64 64"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="calendar"
                    >
                      <path
                        d="M8 24H56M18.6667 8V13.3333M45.3333 8V13.3333M16 34.6667H21.3333M16 45.3333H21.3333M29.3333 34.6667H34.6667M29.3333 45.3333H34.6667M42.6667 34.6667H48M42.6667 45.3333H48M16.5333 56H47.4667C50.4536 56 51.9472 56 53.088 55.4187C54.0915 54.9075 54.9075 54.0915 55.4187 53.088C56 51.9472 56 50.4536 56 47.4667V21.8667C56 18.8797 56 17.3862 55.4187 16.2454C54.9075 15.2418 54.0915 14.4259 53.088 13.9146C51.9472 13.3333 50.4536 13.3333 47.4667 13.3333H16.5333C13.5464 13.3333 12.0529 13.3333 10.9121 13.9146C9.90851 14.4259 9.09261 15.2418 8.58131 16.2454C8 17.3862 8 18.8797 8 21.8667V47.4667C8 50.4536 8 51.9472 8.58131 53.088C9.09261 54.0915 9.90851 54.9075 10.9121 55.4187C12.0529 56 13.5464 56 16.5333 56Z"
                        stroke="#A3A3A3"
                        stroke-width="5.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="exclamation"
                    >
                      <g clip-path="url(#clip0_838_1832)">
                        <path
                          d="M15.8878 0.42041C24.234 0.42041 30.9999 7.18634 30.9999 15.5325C30.9999 23.8788 24.234 30.6447 15.8878 30.6447C7.54157 30.6447 0.775635 23.8788 0.775635 15.5325C0.775635 7.18634 7.54157 0.42041 15.8878 0.42041Z"
                          fill="url(#paint0_linear_838_1832)"
                        />
                        <path
                          d="M15.8879 8.81641C16.3516 8.81641 16.7275 9.19229 16.7275 9.65597V18.0516C16.7275 18.5153 16.3516 18.8912 15.8879 18.8912C15.4242 18.8912 15.0483 18.5153 15.0483 18.0516V9.65597C15.0483 9.19229 15.4242 8.81641 15.8879 8.81641Z"
                          fill="white"
                        />
                        <path
                          d="M15.8879 20.5698C16.3516 20.5698 16.7275 20.9457 16.7275 21.4094C16.7275 21.8731 16.3516 22.249 15.8879 22.249C15.4242 22.249 15.0483 21.8731 15.0483 21.4094C15.0483 20.9457 15.4242 20.5698 15.8879 20.5698Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_838_1832"
                          x1="1511.99"
                          y1="0.42041"
                          x2="1511.99"
                          y2="3022.85"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#F77E17" />
                          <stop offset="1" stop-color="#FFE100" />
                        </linearGradient>
                        <clipPath id="clip0_838_1832">
                          <rect
                            width="30.2243"
                            height="30.2243"
                            fill="white"
                            transform="translate(0.775635 0.42041)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="d-flex align-items-center ml-2 ml-lg-3">
                    <span class="d-block font-size-3 font-size-md-7">
                      <b class="text-primary">Atenção! </b>
                      O teste gratuito do I.A.GO termina em
                      <b class="text-primary">
                        {{ promotionDaysLeft || "-" }} dias.</b
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="w-100 d-flex justify-content-center align-items-center mt-3 pr-5 pr-md-0 pl-1 pl-md-0"
          >
            <div class="input-container form-group mb-0">
              <div
                class="d-flex justify-content-center align-items-center position-relative input-container-floating__button"
              >
                <div class="w-100 input-group mb-0">
                  <input
                    *ngIf="
                      !trainingForm.controls['name'].disabled;
                      else formName
                    "
                    id="form-name"
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    placeholder="Nome treino"
                    formControlName="name"
                    (blur)="toggleNameFieldVisibility('blur')"
                    [ngClass]="{
                      'is-invalid': validateField('name').invalid
                    }"
                  />
                  <ng-template #formName>
                    <span
                      class="block w-100 text-left text-md-center text-bold-600 font-size-5 font-size-md-9 px-2 my-1"
                    >
                      {{ trainingForm.controls["name"].value || "Nome treino" }}
                    </span>
                  </ng-template>
                </div>
                <button
                  type="button"
                  [title]="
                    trainingForm.controls['name'].disabled
                      ? 'Habilitar edição do nome'
                      : 'Parar de editar nome'
                  "
                  (click)="toggleNameFieldVisibility()"
                  class="btn btn-sm d-flex justify-content-center align-items-center floating__button"
                  [ngClass]="{
                    'btn-outline-success':
                      !trainingForm.controls['name'].disabled
                  }"
                >
                  <svg
                    *ngIf="trainingForm.controls['name'].disabled"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 19 19"
                    fill="none"
                    class="m-1"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.2211 0.762396C16.2046 -0.25413 14.5564 -0.254134 13.5399 0.762396L1.25589 13.0464C0.892513 13.4098 0.644822 13.8726 0.544043 14.3765L0.0346636 16.9234C-0.208185 18.1376 0.862371 19.2082 2.07661 18.9653L4.6235 18.4559C5.12741 18.3552 5.59022 18.1075 5.9536 17.7441L18.2376 5.4601C19.2541 4.44357 19.2541 2.79546 18.2376 1.77892L17.2211 0.762396ZM14.7669 1.98945C15.1058 1.65061 15.6552 1.65061 15.9941 1.98945L17.0105 3.00599C17.3494 3.34482 17.3494 3.89419 17.0105 4.23304L14.6925 6.55107L12.449 4.30749L14.7669 1.98945ZM11.2218 5.53455L2.48295 14.2735C2.36182 14.3946 2.27926 14.5489 2.24567 14.7168L1.73629 17.2637L4.28318 16.7543C4.45115 16.7207 4.60542 16.6382 4.72654 16.5171L13.4654 7.77813L11.2218 5.53455Z"
                      fill="#A3A3A3"
                    />
                  </svg>
                  <i
                    *ngIf="!trainingForm.controls['name'].disabled"
                    class="fa ft-check text-bold-600 font-medium-2 m-1"
                  ></i>
                </button>
              </div>
              <ng-container
                [ngTemplateOutlet]="formError"
                [ngTemplateOutletContext]="{
                  validation: 'required',
                  message: 'O nome é obrigatório',
                  control: trainingForm.controls['name']
                }"
              ></ng-container>
            </div>
          </div>

          <div
            class="w-100 d-flex flex-column justify-content-center align-items-center mt-2 mt-md-3 px-1 px-md-0"
          >
            <label for="add-exercises" class="mb-2">ADICIONAR EXERCÍCIO</label>
            <div
              class="d-flex justify-content-center align-items-center position-relative input-container-floating__button"
            >
              <div
                class="w-100 d-flex align-items-center justify-content-center position-relative"
              >
                <ng-select
                  id="add-exercises"
                  [items]="exercisesList"
                  [loading]="exercisesLoading"
                  [typeahead]="input$"
                  [notFoundText]="'Nenhum exercício encontrado'"
                  [loadingText]="'Carregando...'"
                  bindLabel="name"
                  placeholder="Selecione um exercício"
                  class="w-100 ng-custom-select"
                  [(ngModel)]="selectedNewExercise"
                  [ngModelOptions]="{ standalone: true }"
                  (scrollToEnd)="fetchMore(exercise.searchTerm)"
                  #exercise
                >
                  <ng-template ng-option-tmp let-item="item">
                    <span class="font-size-3 font-size-md-5 text-bold-400"
                      >{{ item.name
                      }}<span
                        class="text-muted float-right font-size-3 font-size-md-5 text-bold-400"
                        >{{ item.categoryName }}</span
                      ></span
                    >
                  </ng-template>
                </ng-select>
                <i
                  class="ft-search grey lighten-1 text-bold-600 search-icon__input"
                ></i>
              </div>
              <button
                type="button"
                title="Adicionar exercício"
                [disabled]="!selectedNewExercise || exercisesLoading"
                (click)="
                  selectedNewExercise && !exercisesLoading && addExerciseModal()
                "
                class="btn btn-primary px-2 floating__button"
              >
                <i class="ft-plus white"></i>
              </button>
            </div>
          </div>

          <div
            class="w-100 d-flex justify-content-center align-items-center mt-2 mt-md-3"
          >
            <div
              class="d-flex align-items-center p-1 py-2 p-md-2 border border-grey rounded-lg"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-1 mr-md-2"
              >
                <rect
                  x="0.542969"
                  y="0.43457"
                  width="30.1304"
                  height="30.1304"
                  rx="15.0652"
                  fill="#FF5E19"
                />
                <path
                  d="M15.0041 19.7044C14.8379 19.7044 14.6966 19.6546 14.5803 19.5549C14.4639 19.4385 14.4058 19.2889 14.4058 19.1061V7.68781C14.4058 7.5216 14.4639 7.38033 14.5803 7.26398C14.6966 7.14764 14.8379 7.08947 15.0041 7.08947H17.0235C17.2063 7.08947 17.3476 7.14764 17.4473 7.26398C17.5637 7.38033 17.6218 7.5216 17.6218 7.68781V19.1061C17.6218 19.2889 17.5637 19.4385 17.4473 19.5549C17.3476 19.6546 17.2063 19.7044 17.0235 19.7044H15.0041ZM14.8545 24.541C14.6717 24.541 14.5221 24.4828 14.4058 24.3665C14.306 24.2502 14.2562 24.1089 14.2562 23.9427V21.6241C14.2562 21.4413 14.306 21.2917 14.4058 21.1754C14.5221 21.059 14.6717 21.0008 14.8545 21.0008H17.1731C17.3559 21.0008 17.5055 21.059 17.6218 21.1754C17.7382 21.2917 17.7964 21.4413 17.7964 21.6241V23.9427C17.7964 24.1089 17.7382 24.2502 17.6218 24.3665C17.5055 24.4828 17.3559 24.541 17.1731 24.541H14.8545Z"
                  fill="white"
                />
              </svg>
              <span class="font-size-3 font-size-md-5 text-bold-400"
                >Clique na linha ou nos campos</span
              >
              <span class="p-2 border border-grey rounded mx-1 mx-md-2"></span>
              <span class="font-size-3 font-size-md-5 text-bold-400"
                >para editar seu treino.</span
              >
            </div>
          </div>

          <div
            *ngIf="trainingRaw && trainingRaw.TrainingExercises"
            class="w-100 d-flex flex-column mt-2 mt-md-4"
          >
            <div class="training-datatable">
              <div class="table" formArrayName="exercises">
                <div class="table-head">
                  <div class="head-cell">
                    <div
                      tabindex="-1"
                      class="datatable-row-even justify-content-end justify-content-xl-center"
                    >
                      <div
                        class="custom-control custom-checkbox d-none d-md-block"
                      >
                        <input
                          id="chkBoxAll"
                          type="checkbox"
                          name="chkBoxAll"
                          [checked]="
                            exercises.controls &&
                            exercises.controls.length > 0 &&
                            exercises.controls.length === chkBoxSelected.length
                          "
                          (change)="onCheckboxChangeAllFn($event)"
                          class="custom-control-input cursor-pointer"
                        />
                        <label
                          class="custom-control-label cursor-pointer"
                          for="chkBoxAll"
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="head-cell">
                    <div tabindex="-1" class="datatable-row-even">
                      <span class="font-size-4 font-size-md-5">
                        Exercício
                      </span>
                    </div>
                  </div>
                  <div class="head-cell">
                    <div tabindex="-1" class="datatable-row-even">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 10 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        ngbTooltip="Séries"
                        container="body"
                        placement="top"
                      >
                        <path
                          d="M4.09473 0.422062C4.03036 0.431708 3.86483 0.458232 3.72689 0.479934C3.58665 0.499224 3.34526 0.549861 3.18662 0.590854C3.02799 0.629435 2.80039 0.701774 2.68084 0.75C2.56129 0.795815 2.35898 0.889856 2.23253 0.957372C2.10609 1.02248 1.90837 1.14304 1.79572 1.22262C1.67847 1.30701 1.47846 1.48786 1.33592 1.63736C1.19568 1.78204 1.03015 1.98459 0.968078 2.08345C0.903706 2.18232 0.809446 2.35593 0.75427 2.46926C0.701393 2.58259 0.625525 2.77067 0.59104 2.89124C0.554256 3.00939 0.505977 3.20471 0.482987 3.32527C0.4531 3.4796 0.441604 3.65321 0.441604 3.9281C0.441604 4.18129 0.455399 4.39107 0.480688 4.53816C0.501379 4.65873 0.549658 4.86128 0.588741 4.98425C0.625525 5.10482 0.699094 5.2929 0.751971 5.399C0.802549 5.5051 0.903706 5.6763 0.974975 5.78239C1.04624 5.88608 1.20488 6.06934 1.32442 6.19232C1.44397 6.31288 1.62559 6.47444 1.72675 6.54919C1.82791 6.62153 2.01413 6.74451 2.14057 6.81684C2.26702 6.8916 2.49462 7.00734 2.64636 7.07485C2.79809 7.14237 3.05558 7.24606 3.22111 7.30393C3.38434 7.3618 3.65332 7.44861 3.81885 7.49683C3.98208 7.54506 4.47407 7.67768 4.91088 7.7886C5.34769 7.90193 5.7937 8.02491 5.90635 8.06349C6.01671 8.10448 6.18223 8.17441 6.27419 8.22505C6.36386 8.27327 6.4903 8.36249 6.55237 8.42278C6.61215 8.48306 6.68572 8.5771 6.71331 8.63015C6.75009 8.70731 6.76159 8.77 6.76159 8.93156C6.76159 9.11 6.75239 9.15581 6.69032 9.29325C6.64663 9.38971 6.57077 9.50063 6.4949 9.57779C6.41443 9.66219 6.29948 9.74417 6.16384 9.8141C6.04889 9.87197 5.85348 9.94913 5.72703 9.98048C5.60058 10.0142 5.37298 10.0552 5.22125 10.0697C5.00974 10.0914 4.88329 10.0914 4.68098 10.0697C4.53614 10.0552 4.34992 10.0239 4.26716 10.0022C4.18439 9.98048 4.02346 9.91778 3.91081 9.86232C3.79586 9.80445 3.64872 9.71282 3.58435 9.65978C3.51768 9.60432 3.40733 9.48857 3.34296 9.40418C3.27628 9.31978 3.18432 9.17028 3.13604 9.07383C3.09006 8.97496 3.02799 8.81341 2.99581 8.71454C2.96592 8.61568 2.91534 8.39866 2.88775 8.23228C2.85786 8.0659 2.83487 7.92846 2.83258 7.92363C2.83028 7.91881 2.19345 7.97909 1.41638 8.05385C0.639319 8.1286 0.000194437 8.19129 0.000194437 8.1937C-0.00210457 8.1937 0.0162875 8.36008 0.0392776 8.55781C0.0622677 8.75795 0.0990519 9.01113 0.119743 9.12446C0.138135 9.2378 0.191012 9.45481 0.232395 9.60673C0.273777 9.75864 0.351943 9.99253 0.407119 10.1252C0.462296 10.2578 0.551957 10.4531 0.607133 10.5592C0.662309 10.6653 0.768064 10.8365 0.839333 10.9426C0.910603 11.0463 1.04624 11.2175 1.1405 11.326C1.23476 11.4321 1.3842 11.5816 1.47386 11.6563C1.56122 11.7335 1.72215 11.8541 1.83021 11.9288C1.93826 12.0012 2.14517 12.1217 2.29001 12.1941C2.43485 12.2688 2.64636 12.3604 2.76131 12.4014C2.87396 12.44 3.07167 12.5003 3.19812 12.5341C3.32456 12.5678 3.51538 12.6112 3.62344 12.6305C3.73149 12.6498 3.9269 12.6811 4.06025 12.698C4.20738 12.7173 4.54764 12.7294 4.93387 12.7294C5.32011 12.7294 5.66496 12.7173 5.81899 12.698C5.95693 12.6787 6.20522 12.6401 6.37075 12.6088C6.53398 12.575 6.77768 12.5172 6.91102 12.4762C7.04436 12.4376 7.24438 12.3677 7.35933 12.3194C7.47198 12.2736 7.6582 12.1868 7.77315 12.1265C7.8858 12.0638 8.08352 11.9433 8.20996 11.8541C8.33641 11.7648 8.53642 11.5961 8.65597 11.4755C8.77322 11.3573 8.92495 11.1813 8.99392 11.0897C9.0606 10.9956 9.16865 10.8293 9.23302 10.7159C9.29509 10.6026 9.38935 10.4025 9.43993 10.2698C9.48821 10.1372 9.55488 9.9202 9.58477 9.78757C9.61696 9.65495 9.65374 9.41623 9.66983 9.25709C9.68823 9.08106 9.69282 8.8544 9.68593 8.67837C9.67673 8.51923 9.64914 8.26363 9.62615 8.11172C9.60086 7.9598 9.55029 7.73555 9.5135 7.6174C9.47672 7.49683 9.40315 7.30875 9.34797 7.19542C9.2951 7.08209 9.20543 6.9133 9.14566 6.82167C9.08818 6.72763 8.92495 6.53231 8.78701 6.38763C8.62838 6.22366 8.44446 6.05969 8.30192 5.96083C8.17548 5.87161 7.93638 5.72935 7.77315 5.64495C7.60762 5.55814 7.35013 5.43999 7.1984 5.37971C7.04666 5.31942 6.75239 5.21574 6.54318 5.15063C6.33397 5.08312 5.90635 4.96255 5.58909 4.88298C5.27412 4.80099 4.84881 4.69007 4.64649 4.63461C4.44418 4.58156 4.19129 4.5044 4.08324 4.46582C3.97518 4.42483 3.81425 4.35731 3.72689 4.31391C3.63723 4.27051 3.51538 4.18611 3.45101 4.12824C3.38894 4.06796 3.31767 3.98115 3.29698 3.93292C3.27399 3.8847 3.25559 3.8003 3.25559 3.74725C3.25559 3.6942 3.26939 3.61463 3.28778 3.57123C3.30387 3.53024 3.35905 3.45307 3.40733 3.40485C3.45791 3.35662 3.56366 3.28187 3.64643 3.23847C3.72919 3.19748 3.87403 3.14202 3.96829 3.1179C4.06255 3.09138 4.22808 3.06003 4.33613 3.04556C4.45108 3.02868 4.69248 3.02386 4.92238 3.0311C5.21895 3.04074 5.35689 3.05521 5.49713 3.09379C5.59829 3.12273 5.73393 3.17095 5.796 3.2023C5.86037 3.23364 5.96843 3.31322 6.0374 3.38073C6.11326 3.45066 6.19603 3.56158 6.24201 3.65321C6.28569 3.73761 6.34316 3.91122 6.37075 4.03661C6.40064 4.162 6.43742 4.33561 6.45352 4.42001C6.47191 4.50681 6.4949 4.59121 6.50869 4.6105C6.52709 4.63702 6.70641 4.63461 7.6582 4.59362C8.27663 4.56469 8.92036 4.53575 9.08589 4.5261L9.38935 4.50681C9.37556 4.3766 9.36636 4.20299 9.36177 4.03661C9.35487 3.85576 9.32728 3.61945 9.2928 3.44584C9.26061 3.28669 9.20313 3.05762 9.16175 2.93947C9.12267 2.8189 9.03301 2.60188 8.96174 2.4572C8.89047 2.31011 8.77092 2.10515 8.69505 1.99906C8.62148 1.89296 8.46975 1.71452 8.3617 1.60119C8.25134 1.48786 8.06972 1.33112 7.95707 1.24914C7.84212 1.16716 7.67199 1.05624 7.57773 1.00319C7.48347 0.947727 7.29955 0.86092 7.17081 0.807871C7.03977 0.752411 6.82366 0.675249 6.68802 0.636669C6.55008 0.595676 6.28569 0.537805 6.09487 0.506458C5.90635 0.475111 5.66266 0.43653 5.5546 0.422062C5.44655 0.407594 5.1017 0.397949 4.78444 0.397949C4.46947 0.400361 4.1591 0.410006 4.09473 0.422062Z"
                          fill="#757575"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="head-cell">
                    <div tabindex="-1" class="datatable-row-even">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 21 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        ngbTooltip="Repetições/Duração"
                        container="body"
                        placement="top"
                      >
                        <path
                          d="M6 0.500057C4.91221 0.500057 3.84884 0.822627 2.94437 1.42697C2.0399 2.03132 1.33495 2.89031 0.918665 3.8953C0.502383 4.90029 0.393465 6.00616 0.605683 7.07305C0.817902 8.13995 1.34173 9.11996 2.11092 9.88914C2.8801 10.6583 3.86011 11.1822 4.92701 11.3944C5.9939 11.6066 7.09977 11.4977 8.10476 11.0814C9.10976 10.6651 9.96874 9.96016 10.5731 9.05569C11.1774 8.15122 11.5 7.08785 11.5 6.00006C11.5033 5.27686 11.3633 4.56017 11.0881 3.89139C10.8129 3.2226 10.4079 2.61497 9.89647 2.10359C9.38509 1.59221 8.77746 1.18721 8.10867 0.911978C7.43989 0.63675 6.7232 0.496747 6 0.500057ZM8.925 7.75006C8.88005 7.82334 8.81778 7.88446 8.74368 7.92806C8.66957 7.97165 8.5859 7.99637 8.5 8.00006C8.4113 7.99889 8.3247 7.97291 8.25 7.92506L5.5 6.27506V3.50006C5.5 3.36745 5.55268 3.24027 5.64645 3.1465C5.74022 3.05274 5.86739 3.00006 6 3.00006C6.13261 3.00006 6.25979 3.05274 6.35356 3.1465C6.44732 3.24027 6.5 3.36745 6.5 3.50006V5.72506L8.75 7.07506C8.80769 7.10604 8.85835 7.14862 8.8988 7.20012C8.93924 7.25162 8.9686 7.31092 8.98504 7.37431C9.00147 7.43769 9.00462 7.50379 8.99429 7.56846C8.98396 7.63312 8.96037 7.69495 8.925 7.75006Z"
                          fill="#757575"
                        />
                        <path
                          d="M11 4.6C10.7791 4.6 10.6 4.77909 10.6 5V15.4253C10.6 15.6463 10.7791 15.8253 11 15.8253H13.5452C13.7662 15.8253 13.9452 15.6463 13.9452 15.4253V11.7414C13.9495 11.7426 13.9538 11.7439 13.9582 11.7452C13.9857 11.7537 14.0055 11.7612 14.0145 11.765C14.0173 11.767 14.023 11.7715 14.0324 11.7803C14.0573 11.8035 14.095 11.8437 14.1599 11.9204C14.2545 12.0327 14.3783 12.1895 14.4318 12.2654L14.4318 12.2655L14.4353 12.2703C14.4946 12.3518 14.6849 12.6331 14.8617 12.8983L14.8617 12.8984L14.8629 12.9001C15.0375 13.159 15.3876 13.6972 15.6446 14.0949L15.6454 14.0961C15.903 14.4918 16.2302 15.0017 16.3746 15.2275L16.3747 15.2277L16.6394 15.6411C16.7129 15.7559 16.8399 15.8253 16.9762 15.8253H20C20.149 15.8253 20.2857 15.7425 20.3546 15.6103C20.4236 15.4782 20.4133 15.3187 20.3281 15.1965C20.277 15.1233 20.0785 14.7991 19.8421 14.4051C19.6148 14.0263 19.2964 13.5021 19.1263 13.2219L19.1141 13.2018L19.1129 13.2C18.9425 12.9229 18.6828 12.5097 18.5353 12.2783L18.5353 12.2783L18.534 12.2762C18.3845 12.0449 18.203 11.7705 18.1287 11.6621L18.1287 11.6621L18.1266 11.6591C18.0515 11.5519 17.9308 11.3888 17.8561 11.2942L17.5423 11.5423L17.8561 11.2942C17.8016 11.2253 17.7154 11.1276 17.6292 11.0366C17.7169 10.9917 17.8049 10.9425 17.8684 10.9033L17.8684 10.9033L17.8736 10.9001C17.9731 10.8365 18.1186 10.7366 18.2041 10.6671C18.2933 10.5962 18.4326 10.4623 18.5257 10.3649L18.5257 10.365L18.5289 10.3616C18.6276 10.256 18.761 10.0916 18.8314 9.9847C18.8954 9.88751 18.9861 9.72908 19.0375 9.62139C19.0874 9.51681 19.1522 9.35569 19.1874 9.25237C19.2247 9.14318 19.269 8.97058 19.2928 8.86476L19.2929 8.86479L19.2947 8.85559C19.3186 8.73605 19.349 8.51472 19.3623 8.35133L19.3623 8.35122C19.3803 8.12878 19.3804 7.96409 19.3621 7.74956L19.3621 7.74932C19.3486 7.59174 19.3159 7.37032 19.2901 7.24609L19.2901 7.24608L19.2889 7.2406C19.2612 7.11611 19.2062 6.92024 19.1625 6.7936C19.1172 6.66253 19.032 6.46542 18.9683 6.34282L18.9684 6.3428L18.9655 6.33751C18.9016 6.21872 18.7955 6.04616 18.7225 5.94247L18.7225 5.94246L18.7199 5.93893C18.6406 5.82893 18.4949 5.66383 18.3892 5.55811C18.2773 5.44627 18.0928 5.29286 17.9611 5.20634C17.8468 5.12957 17.6797 5.03057 17.5765 4.9847C17.4898 4.94619 17.3459 4.89104 17.2478 4.8576C17.1324 4.81823 16.9237 4.76932 16.7809 4.74034L16.7809 4.7403L16.7754 4.73927C16.6247 4.71088 16.3879 4.6763 16.2387 4.66273C16.1038 4.65046 15.9288 4.63284 15.8493 4.62199L15.8493 4.62185L15.8385 4.62067C15.7917 4.61558 15.6833 4.61323 15.5618 4.61122C15.4271 4.609 15.2434 4.60701 15.0219 4.60536C14.5788 4.60204 13.9817 4.6 13.3172 4.6H11ZM14.0138 11.7645C14.0129 11.764 14.0125 11.7637 14.0125 11.7637L14.0138 11.7645ZM13.9453 9.133L13.9466 8.73299C13.8239 8.73331 13.6908 8.73348 13.5465 8.73348L13.5452 9.13348C13.6892 9.13348 13.8223 9.13332 13.9453 9.133ZM13.5501 7.65408L13.95 7.65878L13.9513 7.25877L13.5514 7.25407L13.5501 7.65408ZM15.6468 7.69835L15.6493 7.69903C15.671 7.70496 15.7007 7.71435 15.7297 7.72477C15.7438 7.72984 15.7562 7.73457 15.766 7.73856C15.7701 7.74021 15.7732 7.74152 15.7753 7.74246C15.8032 7.75838 15.8436 7.7842 15.8665 7.80049C15.8694 7.80329 15.8738 7.8077 15.8791 7.8135C15.8847 7.8196 15.8901 7.82591 15.8948 7.83167C15.8986 7.83646 15.901 7.8397 15.902 7.84112C15.9025 7.84196 15.9046 7.84539 15.9082 7.8519C15.9132 7.8609 15.9192 7.87253 15.9257 7.8859C15.9392 7.91416 15.9499 7.9404 15.9554 7.95681L16.3348 7.83032L15.9554 7.95681C15.9707 8.00286 15.9715 8.01127 15.9727 8.02253V8.02253C15.975 8.04635 15.9759 8.08863 15.9718 8.20146C15.9637 8.39045 15.9521 8.4225 15.9459 8.43829L15.9459 8.43843C15.9457 8.4387 15.9441 8.4424 15.9403 8.44958C15.9356 8.45846 15.9293 8.46954 15.9215 8.48178C15.9049 8.50797 15.8888 8.52889 15.8792 8.53958L15.8787 8.54011C15.8665 8.55363 15.8447 8.57479 15.8193 8.59605C15.8073 8.60613 15.7967 8.6144 15.7884 8.62039C15.785 8.62281 15.7827 8.62444 15.7812 8.62541C15.7792 8.62636 15.7755 8.62807 15.7699 8.63046C15.7594 8.63491 15.746 8.64013 15.7307 8.64553C15.6989 8.65673 15.67 8.66486 15.6527 8.66856L15.6468 7.69835Z"
                          fill="#757575"
                          stroke="#EDEDED"
                          stroke-width="0.8"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="head-cell">
                    <div tabindex="-1" class="datatable-row-even">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        ngbTooltip="Descanso"
                        container="body"
                        placement="top"
                      >
                        <path
                          d="M6.50065 0.541566C7.6791 0.541566 8.83108 0.891016 9.81092 1.54573C10.7908 2.20044 11.5545 3.131 12.0054 4.21974C12.4564 5.30849 12.5744 6.50651 12.3445 7.66231C12.1146 8.81812 11.5471 9.87979 10.7138 10.7131C9.88054 11.5464 8.81886 12.1138 7.66306 12.3437C6.50726 12.5736 5.30924 12.4557 4.22049 12.0047C3.13175 11.5537 2.20118 10.79 1.54647 9.81017C0.891765 8.83033 0.542315 7.67835 0.542315 6.4999C0.538729 5.71644 0.690397 4.94003 0.988562 4.21551C1.28673 3.49099 1.72548 2.83272 2.27948 2.27873C2.83347 1.72473 3.49174 1.28598 4.21626 0.987814C4.94077 0.689649 5.71719 0.53798 6.50065 0.541566ZM3.3319 8.39573C3.3806 8.47512 3.44805 8.54134 3.52833 8.58856C3.60861 8.63579 3.69926 8.66257 3.79231 8.66657C3.88841 8.6653 3.98223 8.63716 4.06315 8.58532L7.04232 6.79782V3.79157C7.04232 3.64791 6.98525 3.51013 6.88366 3.40855C6.78208 3.30697 6.64431 3.2499 6.50065 3.2499C6.35699 3.2499 6.21921 3.30697 6.11763 3.40855C6.01605 3.51013 5.95898 3.64791 5.95898 3.79157V6.20198L3.52148 7.66448C3.45899 7.69805 3.40411 7.74418 3.36029 7.79997C3.31647 7.85575 3.28466 7.92 3.26686 7.98867C3.24906 8.05734 3.24564 8.12895 3.25684 8.199C3.26803 8.26905 3.29358 8.33603 3.3319 8.39573Z"
                          fill="#757575"
                        />
                        <mask
                          id="path-2-outside-1_676_17489"
                          maskUnits="userSpaceOnUse"
                          x="8"
                          y="6"
                          width="10"
                          height="10"
                          fill="black"
                        >
                          <rect
                            fill="white"
                            x="8"
                            y="6"
                            width="10"
                            height="10"
                          />
                          <path
                            d="M9.945 15C9.835 15 9.74 14.965 9.66 14.895C9.59 14.815 9.555 14.72 9.555 14.61V13.155C9.555 13.045 9.575 12.95 9.615 12.87C9.665 12.78 9.725 12.705 9.795 12.645L13.05 9.465H10.065C9.955 9.465 9.86 9.425 9.78 9.345C9.71 9.265 9.675 9.175 9.675 9.075V7.59C9.675 7.48 9.71 7.39 9.78 7.32C9.86 7.24 9.955 7.2 10.065 7.2H16.395C16.505 7.2 16.595 7.24 16.665 7.32C16.745 7.39 16.785 7.48 16.785 7.59V9.18C16.785 9.26 16.765 9.34 16.725 9.42C16.695 9.49 16.645 9.555 16.575 9.615L13.44 12.735H16.71C16.82 12.735 16.91 12.775 16.98 12.855C17.06 12.935 17.1 13.025 17.1 13.125V14.61C17.1 14.72 17.06 14.815 16.98 14.895C16.91 14.965 16.82 15 16.71 15H9.945Z"
                          />
                        </mask>
                        <path
                          d="M9.945 15C9.835 15 9.74 14.965 9.66 14.895C9.59 14.815 9.555 14.72 9.555 14.61V13.155C9.555 13.045 9.575 12.95 9.615 12.87C9.665 12.78 9.725 12.705 9.795 12.645L13.05 9.465H10.065C9.955 9.465 9.86 9.425 9.78 9.345C9.71 9.265 9.675 9.175 9.675 9.075V7.59C9.675 7.48 9.71 7.39 9.78 7.32C9.86 7.24 9.955 7.2 10.065 7.2H16.395C16.505 7.2 16.595 7.24 16.665 7.32C16.745 7.39 16.785 7.48 16.785 7.59V9.18C16.785 9.26 16.765 9.34 16.725 9.42C16.695 9.49 16.645 9.555 16.575 9.615L13.44 12.735H16.71C16.82 12.735 16.91 12.775 16.98 12.855C17.06 12.935 17.1 13.025 17.1 13.125V14.61C17.1 14.72 17.06 14.815 16.98 14.895C16.91 14.965 16.82 15 16.71 15H9.945Z"
                          fill="#757575"
                        />
                        <path
                          d="M9.66 14.895L9.09557 15.3889L9.12849 15.4265L9.16612 15.4594L9.66 14.895ZM9.615 12.87L8.95938 12.5058L8.95147 12.52L8.94418 12.5346L9.615 12.87ZM9.795 12.645L10.2831 13.2144L10.3016 13.1985L10.3191 13.1815L9.795 12.645ZM13.05 9.465L13.5741 10.0015L14.8909 8.715H13.05V9.465ZM9.78 9.345L9.21557 9.83888L9.23201 9.85767L9.24967 9.87533L9.78 9.345ZM9.78 7.32L9.24967 6.78967L9.24967 6.78967L9.78 7.32ZM16.665 7.32L16.1006 7.81388L16.1335 7.85151L16.1711 7.88443L16.665 7.32ZM16.725 9.42L16.0542 9.08459L16.0443 9.1043L16.0356 9.12456L16.725 9.42ZM16.575 9.615L16.0869 9.04556L16.0657 9.06371L16.0459 9.0834L16.575 9.615ZM13.44 12.735L12.9109 12.2034L11.6232 13.485H13.44V12.735ZM16.98 12.855L16.4156 13.3489L16.432 13.3677L16.4497 13.3853L16.98 12.855ZM16.98 14.895L16.4497 14.3647L16.4497 14.3647L16.98 14.895ZM9.945 14.25C9.97081 14.25 10.0081 14.2544 10.0505 14.27C10.0933 14.2858 10.1283 14.3082 10.1539 14.3306L9.16612 15.4594C9.38796 15.6535 9.66025 15.75 9.945 15.75V14.25ZM10.2244 14.4011C10.2468 14.4267 10.2692 14.4617 10.285 14.5045C10.3006 14.5469 10.305 14.5842 10.305 14.61H8.805C8.805 14.8947 8.90146 15.167 9.09557 15.3889L10.2244 14.4011ZM10.305 14.61V13.155H8.805V14.61H10.305ZM10.305 13.155C10.305 13.1352 10.3085 13.1601 10.2858 13.2054L8.94418 12.5346C8.84151 12.7399 8.805 12.9548 8.805 13.155H10.305ZM10.2706 13.2342C10.2767 13.2233 10.2811 13.2173 10.2832 13.2148C10.2851 13.2124 10.2851 13.2127 10.2831 13.2144L9.30691 12.0756C9.16191 12.1998 9.04759 12.347 8.95938 12.5058L10.2706 13.2342ZM10.3191 13.1815L13.5741 10.0015L12.5259 8.92852L9.27089 12.1085L10.3191 13.1815ZM13.05 8.715H10.065V10.215H13.05V8.715ZM10.065 8.715C10.1032 8.715 10.1516 8.72243 10.2023 8.74377C10.2526 8.76494 10.2884 8.79278 10.3103 8.81467L9.24967 9.87533C9.46583 10.0915 9.74983 10.215 10.065 10.215V8.715ZM10.3444 8.85112C10.3611 8.87015 10.3831 8.9016 10.4003 8.94567C10.4177 8.99041 10.425 9.03537 10.425 9.075H8.925C8.925 9.36874 9.03413 9.63153 9.21557 9.83888L10.3444 8.85112ZM10.425 9.075V7.59H8.925V9.075H10.425ZM10.425 7.59C10.425 7.61517 10.4208 7.65898 10.4003 7.71183C10.3791 7.76623 10.347 7.81369 10.3103 7.85033L9.24967 6.78967C9.02277 7.01657 8.925 7.30531 8.925 7.59H10.425ZM10.3103 7.85033C10.2884 7.87221 10.2526 7.90006 10.2023 7.92123C10.1516 7.94257 10.1032 7.95 10.065 7.95V6.45C9.74983 6.45 9.46583 6.57351 9.24967 6.78967L10.3103 7.85033ZM10.065 7.95H16.395V6.45H10.065V7.95ZM16.395 7.95C16.3574 7.95 16.3019 7.94271 16.2404 7.91536C16.1782 7.88772 16.1315 7.8492 16.1006 7.81388L17.2294 6.82612C17.0115 6.577 16.7127 6.45 16.395 6.45V7.95ZM16.1711 7.88443C16.1358 7.85352 16.0973 7.8068 16.0696 7.7446C16.0423 7.68307 16.035 7.62763 16.035 7.59H17.535C17.535 7.27232 17.408 6.97355 17.1589 6.75557L16.1711 7.88443ZM16.035 7.59V9.18H17.535V7.59H16.035ZM16.035 9.18C16.035 9.13043 16.0483 9.0963 16.0542 9.08459L17.3958 9.75541C17.4817 9.58369 17.535 9.38957 17.535 9.18H16.035ZM16.0356 9.12456C16.0594 9.0691 16.0878 9.04477 16.0869 9.04556L17.0631 10.1844C17.2022 10.0652 17.3306 9.9109 17.4144 9.71544L16.0356 9.12456ZM16.0459 9.0834L12.9109 12.2034L13.9691 13.2666L17.1041 10.1466L16.0459 9.0834ZM13.44 13.485H16.71V11.985H13.44V13.485ZM16.71 13.485C16.6724 13.485 16.6169 13.4777 16.5554 13.4504C16.4932 13.4227 16.4465 13.3842 16.4156 13.3489L17.5444 12.3611C17.3265 12.112 17.0277 11.985 16.71 11.985V13.485ZM16.4497 13.3853C16.4341 13.3698 16.4072 13.3378 16.3846 13.2871C16.3614 13.2347 16.35 13.1783 16.35 13.125H17.85C17.85 12.7993 17.7108 12.5252 17.5103 12.3247L16.4497 13.3853ZM16.35 13.125V14.61H17.85V13.125H16.35ZM16.35 14.61C16.35 14.5718 16.3574 14.5234 16.3788 14.4727C16.3999 14.4224 16.4278 14.3866 16.4497 14.3647L17.5103 15.4253C17.7265 15.2092 17.85 14.9252 17.85 14.61H16.35ZM16.4497 14.3647C16.4863 14.328 16.5338 14.2959 16.5882 14.2747C16.641 14.2542 16.6848 14.25 16.71 14.25V15.75C16.9947 15.75 17.2834 15.6522 17.5103 15.4253L16.4497 14.3647ZM16.71 14.25H9.945V15.75H16.71V14.25Z"
                          fill="#EDEDED"
                          mask="url(#path-2-outside-1_676_17489)"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="head-cell">
                    <div tabindex="-1" class="datatable-row-even">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        ngbTooltip="Carga Sugerida"
                        container="body"
                        placement="top"
                      >
                        <g id="SVGRepo_iconCarrier">
                          <path
                            id="Vector"
                            d="M6.62298 0.583984C5.29029 0.583984 4.1985 1.67577 4.1985 3.00847C4.1985 3.77165 4.55694 4.45535 5.11324 4.90075H2.83842L0 13.416H13.246L10.4075 4.90075H8.13273C8.68903 4.45535 9.04747 3.77165 9.04747 3.00847C9.04747 1.67577 7.95568 0.583984 6.62298 0.583984ZM6.62298 1.64839C7.38043 1.64839 7.98306 2.25102 7.98306 3.00847C7.98306 3.76591 7.38043 4.36855 6.62298 4.36855C5.86554 4.36855 5.26291 3.76591 5.26291 3.00847C5.26291 2.25102 5.86554 1.64839 6.62298 1.64839ZM4.19214 7.64899H4.88696V8.63248L5.88848 7.64896H6.69516L5.39767 8.92478L6.82871 10.3432H5.95891L4.88696 9.28212V10.3432H4.19214V7.64899ZM7.73822 8.27699C7.87896 8.27699 8.0029 8.30461 8.10996 8.35996C8.21699 8.41531 8.3151 8.50247 8.40415 8.62163V8.32211H9.0538V10.1394C9.0538 10.4642 8.9509 10.712 8.74518 10.8828C8.54066 11.0549 8.24349 11.1409 7.85368 11.1409C7.72737 11.1409 7.60531 11.1313 7.48734 11.112C7.36949 11.0928 7.25093 11.0633 7.13183 11.0236V10.5201C7.24495 10.5851 7.35565 10.6332 7.46387 10.6645C7.5722 10.697 7.68109 10.7132 7.79058 10.7132C8.00234 10.7132 8.15751 10.6669 8.25614 10.5743C8.35481 10.4816 8.40415 10.3367 8.40415 10.1394V10.0004C8.31516 10.1183 8.21705 10.2049 8.10996 10.2603C8.00293 10.3155 7.87896 10.3433 7.73822 10.3433C7.49154 10.3433 7.28768 10.2464 7.12648 10.0528C6.96525 9.85785 6.88462 9.61002 6.88462 9.30926C6.88462 9.00727 6.96525 8.76003 7.12648 8.56755C7.28768 8.37388 7.49154 8.27699 7.73822 8.27699ZM7.97824 8.74255C7.84469 8.74255 7.74058 8.79193 7.66602 8.89054C7.59142 8.98923 7.55413 9.12879 7.55413 9.30926C7.55413 9.49453 7.59021 9.63527 7.66241 9.73148C7.73461 9.82654 7.8399 9.87408 7.97824 9.87408C8.11298 9.87408 8.21762 9.8247 8.29224 9.72607C8.36681 9.6274 8.40412 9.48847 8.40412 9.30923C8.40412 9.12876 8.36681 8.9892 8.29221 8.89057C8.21762 8.7919 8.11298 8.74255 7.97821 8.74255H7.97824Z"
                            fill="#757575"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div class="head-cell d-none d-md-flex">
                    <div tabindex="-1" class="datatable-row-even">
                      <svg
                        fill="#000000"
                        version="1.1"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        enable-background="new 0 0 20 20"
                        ngbTooltip="Carga Sugerida"
                        container="body"
                        placement="top"
                      >
                        <g id="SVGRepo_bgCarrier" stroke-width="0" />
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M10,20C4.5,20,0,15.5,0,10S4.5,0,10,0s10,4.5,10,10S15.5,20,10,20z M10,2c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S14.4,2,10,2 z"
                          />
                          <path
                            d="M8.6,11.4c-0.8-0.8-2.8-5.7-2.8-5.7s4.9,2,5.7,2.8c0.8,0.8,0.8,2,0,2.8C10.6,12.2,9.4,12.2,8.6,11.4z"
                          />
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div class="head-cell"></div>
                </div>
                <ul
                  cdkDropList
                  (cdkDropListDropped)="onDrop($event)"
                  class="table-body"
                >
                  <li
                    cdkDrag
                    *ngFor="let exercise of exercises.controls; let i = index"
                    class="table-row"
                    [ngClass]="{
                      checked: verifyChkBoxSelected(exercise.value.id)
                    }"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        template;
                        context: {
                          expanded: verifyRowExpanded(exercise.value.id)
                        }
                      "
                    ></ng-container>
                    <ng-template
                      #template
                      let-expanded="expanded"
                      [formGroupName]="i"
                    >
                      <div
                        class="row-wrapper"
                        role="row"
                        (click)="toggleRowExpand(exercise.value.id)"
                      >
                        <div class="body-cell">
                          <div
                            class="w-100 d-flex justify-content-start align-items-center"
                          >
                            <a
                              href="javascript:void(0)"
                              [class.datatable-icon-right]="!expanded"
                              [class.datatable-icon-down]="expanded"
                              title="Expand/Collapse Row"
                              (click)="
                                preventDefault(
                                  $event,
                                  toggleRowExpand(exercise.value.id)
                                )
                              "
                            >
                            </a>
                            <div
                              class="custom-control custom-checkbox ml-1 ml-md-3"
                            >
                              <input
                                id="chkBox-{{ i }}"
                                type="checkbox"
                                name="chkBox-{{ i }}"
                                [checked]="
                                  verifyChkBoxSelected(exercise.value.id)
                                "
                                (change)="
                                  preventDefault(
                                    $event,
                                    onCheckboxChangeFn(exercise.value.id)
                                  )
                                "
                                class="custom-control-input cursor-pointer"
                              />
                              <label
                                class="custom-control-label cursor-pointer"
                                for="chkBox-{{ i }}"
                              ></label>
                            </div>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div tabindex="-1" class="datatable-row-even">
                            <span
                              *ngIf="clientDevice === 'desktop'"
                              id="exe-dektop-{{ i }}"
                              placement="right"
                              [ngbTooltip]="exercise.value.name"
                              container="body"
                              (click)="preventDefault($event, '')"
                              class="font-size-4 font-size-md-5"
                            >
                              {{ exercise.value.name || "-" }}
                            </span>
                            <span
                              *ngIf="clientDevice === 'mobile'"
                              id="exe-mobile-{{ i }}"
                              placement="right"
                              [ngbTooltip]="exercise.value.name"
                              triggers="click:blur"
                              container="body"
                              (click)="preventDefault($event, '')"
                              class="font-size-4 font-size-md-5"
                            >
                              {{ exercise.value.name || "-" }}
                            </span>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div tabindex="-1" class="datatable-row-even">
                            <button
                              type="button"
                              ngbTooltip="Clique para editar"
                              container="body"
                              (click)="
                                preventDefault(
                                  $event,
                                  expandAndFocus(
                                    exercise.value.id,
                                    'series-' + i
                                  )
                                )
                              "
                              class="btn btn-outline-grey btn-sm px-1 px-md-2 edit__button"
                              [ngClass]="{
                                invalid: validateField('series', i).invalid,
                                valid: validateField('series', i).valid
                              }"
                            >
                              <span
                                class="text-cell font-size-4 font-size-md-5"
                              >
                                {{ exercise.value.series || "-" }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div tabindex="-1" class="datatable-row-even">
                            <button
                              type="button"
                              ngbTooltip="Clique para editar"
                              container="body"
                              (click)="
                                preventDefault(
                                  $event,
                                  expandAndFocus(
                                    exercise.value.id,
                                    !!repMode[i + '-rep']
                                      ? i + '-durationSecond'
                                      : 'rep-' + i
                                  )
                                )
                              "
                              class="btn btn-outline-grey btn-sm px-1 px-md-2 edit__button"
                              [ngClass]="
                                !!!repMode[i + '-rep']
                                  ? {
                                      invalid: validateField('repetitions', i)
                                        .invalid,
                                      valid: validateField('repetitions', i)
                                        .valid
                                    }
                                  : {
                                      invalid: validateField('duration', i)
                                        .invalid,
                                      valid: validateField('duration', i).valid
                                    }
                              "
                            >
                              <span
                                class="text-cell font-size-4 font-size-md-5"
                              >
                                {{
                                  !!!repMode[i + "-rep"]
                                    ? exercise.value.repetitions
                                      ? exercise.value.repetitions
                                      : "-"
                                    : exercise.value.duration
                                    ? (exercise.value.duration | objToSec)
                                    : "-"
                                }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div tabindex="-1" class="datatable-row-even">
                            <button
                              type="button"
                              ngbTooltip="Clique para editar"
                              container="body"
                              (click)="
                                preventDefault(
                                  $event,
                                  expandAndFocus(
                                    exercise.value.id,
                                    i + '-breakTimeSecond'
                                  )
                                )
                              "
                              class="btn btn-outline-grey btn-sm px-1 px-md-2 edit__button"
                              [ngClass]="{
                                invalid: validateField('breakTime', i).invalid,
                                valid: validateField('breakTime', i).valid
                              }"
                            >
                              <span
                                class="text-cell font-size-4 font-size-md-5"
                              >
                                {{
                                  exercise.value.breakTime
                                    ? (exercise.value.breakTime
                                      | objToSec : "hour")
                                    : "-"
                                }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div tabindex="-1" class="datatable-row-even">
                            <button
                              type="button"
                              ngbTooltip="Clique para editar"
                              container="body"
                              (click)="
                                preventDefault(
                                  $event,
                                  expandAndFocus(
                                    exercise.value.id,
                                    'load-input-' + i
                                  )
                                )
                              "
                              class="btn btn-outline-grey btn-sm px-1 px-md-2 edit__button"
                              [ngClass]="{
                                invalid: validateField('load', i).invalid,
                                valid: validateField('load', i).valid
                              }"
                            >
                              <span
                                class="text-cell font-size-4 font-size-md-5 load__text"
                              >
                                {{
                                  loadMode[i + "-load"]
                                    ? !!exercise.value.load
                                      ? exercise.value.load
                                      : "-"
                                    : !!exercise.value.load
                                    ? "Corporal"
                                    : "-"
                                }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="body-cell d-none d-md-flex">
                          <div tabindex="-1" class="datatable-row-even">
                            <button
                              type="button"
                              ngbTooltip="Clique para editar"
                              container="body"
                              (click)="
                                preventDefault(
                                  $event,
                                  expandAndFocus(
                                    exercise.value.id,
                                    'speed-' + i
                                  )
                                )
                              "
                              class="btn btn-outline-grey btn-sm px-1 px-md-2 edit__button"
                              [ngClass]="{
                                invalid: validateField('speed', i).invalid,
                                valid: validateField('speed', i).valid
                              }"
                            >
                              <span
                                class="text-cell font-size-4 font-size-md-5"
                              >
                                {{ (exercise.value.speed | translate) || "-" }}
                              </span>
                            </button>
                          </div>
                        </div>
                        <div class="body-cell">
                          <div
                            class="w-100 d-flex justify-content-end align-items-center"
                          >
                            <div
                              class="w-100 d-none d-md-flex justify-content-end align-items-center action__buttons"
                            >
                              <button
                                type="button"
                                ngbTooltip="Ver mídia"
                                container="body"
                                (click)="
                                  preventDefault(
                                    $event,
                                    viewExerciseMediaModal(i)
                                  )
                                "
                                class="btn btn-sm px-1 d-flex justify-content-center align-items-center grey darken-1"
                              >
                                <svg
                                  width="16"
                                  height="15"
                                  viewBox="0 0 18 17"
                                  fill="currentColor"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.59483 0.0827637C7.44494 0.0838831 6.47476 0.0913068 5.64893 0.140419V3.65973H8.59483V0.0827637Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.38623 0.269043C3.35707 0.432549 2.61742 0.73937 2.04168 1.31512C1.46593 1.89086 1.15911 2.63051 0.995605 3.65966H4.38623V0.269043Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M0.808594 8.49957C0.808594 7.06828 0.808594 5.89519 0.866451 4.92236H17.5845C17.6423 5.89519 17.6423 7.06828 17.6423 8.49957C17.6423 9.93077 17.6423 11.1039 17.5845 12.0767H0.866451C0.808594 11.1039 0.808594 9.93077 0.808594 8.49957ZM9.57157 7.15666C10.4631 7.75585 10.9088 8.05549 10.9088 8.49974C10.9088 8.94398 10.4631 9.24362 9.57157 9.84282C8.66785 10.4502 8.21595 10.7539 7.87902 10.5309C7.54209 10.3079 7.54209 9.7052 7.54209 8.49974C7.54209 7.29427 7.54209 6.69157 7.87902 6.46859C8.21595 6.24561 8.66785 6.5493 9.57157 7.15666Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M17.4561 3.65966C17.2925 2.63051 16.9857 1.89086 16.41 1.31512C15.8342 0.73937 15.0946 0.432549 14.0654 0.269043V3.65966H17.4561Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M9.85645 0.0827637C11.0064 0.0838831 11.9765 0.0913068 12.8024 0.140419V3.65973H9.85645V0.0827637Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M17.4561 13.3394H14.0654V16.7299C15.0946 16.5665 15.8342 16.2596 16.41 15.6839C16.9857 15.1082 17.2925 14.3685 17.4561 13.3394Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M12.8024 13.3394V16.8586C11.9765 16.9078 11.0064 16.9152 9.85645 16.9163V13.3394H12.8024Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.59483 16.9163V13.3394H5.64893V16.8586C6.47476 16.9078 7.44494 16.9152 8.59483 16.9163Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.38623 13.3394V16.7299C3.35707 16.5665 2.61742 16.2596 2.04168 15.6839C1.46593 15.1082 1.15911 14.3685 0.995605 13.3394H4.38623Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </button>
                              <button
                                type="button"
                                ngbTooltip="Substituir exercício"
                                container="body"
                                (click)="
                                  preventDefault(
                                    $event,
                                    replaceExerciseModal(i)
                                  )
                                "
                                class="btn btn-sm px-1 ml-1 d-flex justify-content-center align-items-center"
                              >
                                <i
                                  class="ft-refresh-ccw grey darken-1 font-small-3"
                                ></i>
                              </button>
                              <button
                                type="button"
                                placement="left"
                                ngbTooltip="Duplicar exercício."
                                (click)="
                                  preventDefault($event, duplicateExercise(i))
                                "
                                class="btn btn-sm px-1 ml-1 d-flex justify-content-center align-items-center"
                              >
                                <i
                                  class="fa fa-copy grey darken-1 font-small-3"
                                ></i>
                              </button>
                              <button
                                type="button"
                                ngbTooltip="Remover exercício"
                                container="body"
                                (click)="
                                  preventDefault(
                                    $event,
                                    removeExerciseModal(exercise.value.id)
                                  )
                                "
                                class="btn btn-sm px-1 ml-1 d-flex justify-content-center align-items-center"
                              >
                                <i
                                  class="ft-trash-2 grey darken-1 font-small-3"
                                ></i>
                              </button>
                            </div>
                            <div
                              class="dropdown d-md-none btn-group-sm action__buttons"
                              [isOpen]="isOpen"
                              ngbDropdown
                              container="body"
                            >
                              <button
                                id="dropdownBasic"
                                type="button"
                                class="btn btn-sm shadow-none dropdown-toggle px-1"
                                ngbDropdownToggle
                                (click)="preventDefault($event, '')"
                              >
                                <i class="ft-more-vertical"></i>
                              </button>
                              <div
                                ngbDropdownMenu
                                class="dropdown-menu"
                                role="group"
                              >
                                <button
                                  type="button"
                                  ngbTooltip="Ver mídia"
                                  container="body"
                                  (click)="
                                    preventDefault(
                                      $event,
                                      viewExerciseMediaModal(i)
                                    )
                                  "
                                  class="w-100 dropdown-item d-flex justify-content-start align-items-center px-2 grey darken-1"
                                >
                                  <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 18 17"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M8.59483 0.0827637C7.44494 0.0838831 6.47476 0.0913068 5.64893 0.140419V3.65973H8.59483V0.0827637Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M4.38623 0.269043C3.35707 0.432549 2.61742 0.73937 2.04168 1.31512C1.46593 1.89086 1.15911 2.63051 0.995605 3.65966H4.38623V0.269043Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M0.808594 8.49957C0.808594 7.06828 0.808594 5.89519 0.866451 4.92236H17.5845C17.6423 5.89519 17.6423 7.06828 17.6423 8.49957C17.6423 9.93077 17.6423 11.1039 17.5845 12.0767H0.866451C0.808594 11.1039 0.808594 9.93077 0.808594 8.49957ZM9.57157 7.15666C10.4631 7.75585 10.9088 8.05549 10.9088 8.49974C10.9088 8.94398 10.4631 9.24362 9.57157 9.84282C8.66785 10.4502 8.21595 10.7539 7.87902 10.5309C7.54209 10.3079 7.54209 9.7052 7.54209 8.49974C7.54209 7.29427 7.54209 6.69157 7.87902 6.46859C8.21595 6.24561 8.66785 6.5493 9.57157 7.15666Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M17.4561 3.65966C17.2925 2.63051 16.9857 1.89086 16.41 1.31512C15.8342 0.73937 15.0946 0.432549 14.0654 0.269043V3.65966H17.4561Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M9.85645 0.0827637C11.0064 0.0838831 11.9765 0.0913068 12.8024 0.140419V3.65973H9.85645V0.0827637Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M17.4561 13.3394H14.0654V16.7299C15.0946 16.5665 15.8342 16.2596 16.41 15.6839C16.9857 15.1082 17.2925 14.3685 17.4561 13.3394Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M12.8024 13.3394V16.8586C11.9765 16.9078 11.0064 16.9152 9.85645 16.9163V13.3394H12.8024Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M8.59483 16.9163V13.3394H5.64893V16.8586C6.47476 16.9078 7.44494 16.9152 8.59483 16.9163Z"
                                      fill="currentColor"
                                    />
                                    <path
                                      d="M4.38623 13.3394V16.7299C3.35707 16.5665 2.61742 16.2596 2.04168 15.6839C1.46593 15.1082 1.15911 14.3685 0.995605 13.3394H4.38623Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                  <span class="d-block ml-2 font-size-5">
                                    Ver mídia
                                  </span>
                                </button>
                                <button
                                  type="button"
                                  ngbTooltip="Substituir exercício"
                                  container="body"
                                  (click)="
                                    preventDefault(
                                      $event,
                                      replaceExerciseModal(i)
                                    )
                                  "
                                  class="w-100 dropdown-item d-flex justify-content-start align-items-center px-2"
                                >
                                  <i
                                    class="ft-refresh-ccw grey darken-1 font-small-3"
                                  ></i>
                                  <span class="d-block ml-2 font-size-5">
                                    Substituir exercício
                                  </span>
                                </button>
                                <button
                                  type="button"
                                  ngbTooltip="Duplicar exercício"
                                  container="body"
                                  (click)="
                                    preventDefault($event, duplicateExercise(i))
                                  "
                                  class="w-100 dropdown-item d-flex justify-content-start align-items-center px-2"
                                >
                                  <i
                                    class="fa fa-copy grey darken-1 font-small-3"
                                  ></i>
                                  <span class="d-block ml-2 font-size-5">
                                    Duplicar exercício
                                  </span>
                                </button>
                                <button
                                  type="button"
                                  ngbTooltip="Remover exercício"
                                  container="body"
                                  (click)="
                                    preventDefault(
                                      $event,
                                      removeExerciseModal(exercise.value.id)
                                    )
                                  "
                                  class="w-100 dropdown-item d-flex justify-content-start align-items-center px-2"
                                >
                                  <i
                                    class="ft-trash-2 grey darken-1 font-small-3"
                                  ></i>
                                  <span class="d-block ml-2 font-size-5">
                                    Remover exercício
                                  </span>
                                </button>
                              </div>
                            </div>
                            <div
                              class="px-1 d-flex justify-content-center align-items-center"
                            >
                              <i
                                class="fa fa-reorder grey darken-1 font-size-6 font-size-md-7"
                                cdkDragHandle
                                style="cursor: grab"
                                placement="left"
                                [ngbTooltip]="tipContent"
                                (click)="preventDefault($event, '')"
                              ></i>
                              <ng-template #tipContent>
                                <span class="drag-tooltip__text">
                                  Arraste para reordenar este exercício.
                                </span>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="expanded" class="row-details">
                        <div class="row">
                          <div class="col-12 col-md-3">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3 pr-md-4"
                            >
                              <div class="form-group">
                                <label
                                  for="series-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                >
                                  Séries
                                </label>
                                <div class="input-group m-0">
                                  <input
                                    id="series-{{ i }}"
                                    type="text"
                                    autocomplete="off"
                                    formControlName="series"
                                    aria-describedby="group-series"
                                    (keydown.enter)="$event.preventDefault()"
                                    class="form-control"
                                    [ngClass]="{
                                      'is-invalid': validateField('series', i)
                                        .invalid,
                                      'is-valid': validateField('series', i)
                                        .valid
                                    }"
                                  />
                                  <div class="input-group-append">
                                    <span
                                      id="group-series"
                                      class="input-group-text font-size-4 font-size-md-5"
                                    >
                                      séries
                                    </span>
                                  </div>
                                </div>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message:
                                      'A quantidade de séries é obrigatória',
                                    control:
                                      exercises.controls[i].controls['series']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'notZero',
                                    message:
                                      'A quantidade de séries não pode ser zero',
                                    control:
                                      exercises.controls[i].controls['series']
                                  }"
                                ></ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-5">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3"
                            >
                              <div class="form-group">
                                <label
                                  for="rep-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                  >Repetições/Tempo</label
                                >
                                <div
                                  class="w-100 d-flex justify-content-start align-items-center"
                                >
                                  <div
                                    id="{{ i }}-rep"
                                    role="group"
                                    class="d-flex align-items-center position-relative"
                                  >
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 9 12"
                                      fill="currentColor"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="switch__icon mr-2"
                                      [ngClass]="{
                                        grey: !!repMode[i + '-rep'],
                                        active: !!!repMode[i + '-rep']
                                      }"
                                    >
                                      <path
                                        id="Vector"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0 0.876953H2.27739C3.58218 0.876953 4.62081 0.884958 4.71287 0.894964C4.80092 0.906971 4.98103 0.924982 5.11311 0.93699C5.24519 0.948997 5.46533 0.981016 5.60341 1.00703C5.7415 1.03505 5.92561 1.07908 6.01366 1.10909C6.10172 1.13911 6.23179 1.18914 6.30384 1.22116C6.37588 1.25318 6.51997 1.33723 6.62403 1.40728C6.7281 1.47532 6.8902 1.6094 6.98425 1.70346C7.07831 1.79751 7.20639 1.9436 7.26843 2.02965C7.33046 2.11771 7.42652 2.2738 7.48256 2.37787C7.53659 2.48193 7.61263 2.65804 7.65066 2.7681C7.68868 2.87817 7.73871 3.05628 7.76273 3.16435C7.78474 3.27041 7.81476 3.47253 7.82677 3.61262C7.84277 3.80073 7.84277 3.94082 7.82677 4.13894C7.81476 4.28703 7.78674 4.48915 7.76673 4.58921C7.74472 4.68727 7.70469 4.84137 7.67467 4.92942C7.64465 5.01747 7.58662 5.16156 7.54459 5.24961C7.50257 5.33767 7.42252 5.47775 7.36849 5.5598C7.31445 5.64185 7.19838 5.78594 7.11233 5.878C7.02428 5.97005 6.9002 6.08813 6.83416 6.14016C6.76812 6.19419 6.63804 6.28425 6.54398 6.34428C6.44993 6.40232 6.28783 6.48837 6.18376 6.5324C6.0797 6.57842 5.94962 6.63046 5.79353 6.68449L5.86357 6.73652C5.90159 6.76454 6.01766 6.8706 6.11973 6.96866C6.22379 7.06872 6.36187 7.22081 6.42991 7.30687C6.49796 7.39292 6.61203 7.54701 6.68207 7.64707C6.75211 7.74914 6.92822 8.0153 7.07431 8.24144C7.21839 8.46757 7.47255 8.87182 7.63865 9.14198C7.80275 9.41215 8.12495 9.94247 8.35309 10.3227C8.58122 10.7029 8.78535 11.0371 8.84539 11.1232H5.87358L5.61342 10.7169C5.47133 10.4948 5.14914 9.9925 4.89498 9.60226C4.64283 9.21203 4.29662 8.6797 4.12251 8.42155C3.95041 8.16339 3.75829 7.87922 3.69425 7.79116C3.63221 7.70311 3.50213 7.53901 3.40607 7.42494C3.27399 7.26884 3.20795 7.20681 3.13191 7.17078C3.07587 7.14477 2.97381 7.11275 2.90177 7.10074C2.82972 7.09074 2.71165 7.08073 2.50152 7.08073V11.1232H0V0.876953ZM2.50152 4.93943C3.6102 4.93943 4.06247 4.92942 4.22257 4.91741C4.38267 4.90741 4.57479 4.88339 4.65283 4.86738C4.72888 4.85137 4.83695 4.81335 4.89098 4.78333C4.94501 4.75331 5.03306 4.67927 5.0871 4.61923C5.14313 4.55719 5.20317 4.46113 5.22718 4.3991C5.2592 4.31705 5.27121 4.22699 5.27921 4.03888C5.28722 3.81874 5.28122 3.77272 5.24319 3.65865C5.21918 3.5866 5.17315 3.49255 5.14313 3.44852C5.11311 3.40449 5.05908 3.34446 5.02106 3.31644C4.98303 3.28842 4.91699 3.2464 4.87297 3.22238C4.82894 3.20037 4.73889 3.16835 4.67285 3.15034C4.57278 3.12232 4.38867 3.11432 3.53015 3.10431L2.50753 3.0923L2.50152 4.93943Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                    <ui-switch
                                      class="switchery switchery-warning"
                                      size="small"
                                      id="rep-mode-switch-{{ i }}"
                                      [checked]="!!repMode[i + '-rep']"
                                      (change)="switchRepMode(i)"
                                    >
                                    </ui-switch>
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 14 14"
                                      fill="currentColor"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="switch__icon ml-2"
                                      [ngClass]="{
                                        grey: !!!repMode[i + '-rep'],
                                        active: !!repMode[i + '-rep']
                                      }"
                                    >
                                      <g id="SVGRepo_iconCarrier">
                                        <g id="Layer 2">
                                          <g id="icons Q2">
                                            <path
                                              id="Vector"
                                              d="M6.99838 1.04157C5.81993 1.04157 4.66795 1.39102 3.6881 2.04573C2.70826 2.70044 1.94457 3.631 1.49359 4.71974C1.04262 5.80849 0.924626 7.00651 1.15453 8.16231C1.38443 9.31812 1.95191 10.3798 2.7852 11.2131C3.61849 12.0464 4.68016 12.6138 5.83596 12.8437C6.99177 13.0736 8.18979 12.9557 9.27853 12.5047C10.3673 12.0537 11.2978 11.29 11.9525 10.3102C12.6073 9.33033 12.9567 8.17835 12.9567 6.9999C12.9603 6.21644 12.8086 5.44003 12.5105 4.71551C12.2123 3.99099 11.7735 3.33272 11.2195 2.77873C10.6656 2.22473 10.0073 1.78598 9.28277 1.48781C8.55825 1.18965 7.78184 1.03798 6.99838 1.04157ZM10.1671 8.89573C10.1184 8.97512 10.051 9.04134 9.97069 9.08856C9.89041 9.13579 9.79976 9.16257 9.70671 9.16657C9.61062 9.1653 9.5168 9.13716 9.43587 9.08532L6.45671 7.29782V4.29157C6.45671 4.14791 6.51378 4.01013 6.61536 3.90855C6.71694 3.80697 6.85472 3.7499 6.99838 3.7499C7.14203 3.7499 7.27981 3.80697 7.38139 3.90855C7.48297 4.01013 7.54004 4.14791 7.54004 4.29157V6.70198L9.97754 8.16448C10.04 8.19805 10.0949 8.24418 10.1387 8.29997C10.1826 8.35575 10.2144 8.42 10.2322 8.48867C10.25 8.55734 10.2534 8.62895 10.2422 8.699C10.231 8.76905 10.2054 8.83603 10.1671 8.89573Z"
                                              fill="currentColor"
                                            />
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </div>
                                  <div
                                    class="d-flex flex-column align-items-start ml-3"
                                  >
                                    <ng-template
                                      [ngIf]="!!!repMode[i + '-rep']"
                                    >
                                      <div class="input-group m-0">
                                        <input
                                          id="rep-{{ i }}"
                                          type="text"
                                          autocomplete="off"
                                          formControlName="repetitions"
                                          aria-describedby="group-repetition"
                                          (keydown.enter)="
                                            $event.preventDefault()
                                          "
                                          class="form-control"
                                          [ngClass]="{
                                            'is-invalid': validateField(
                                              'repetitions',
                                              i
                                            ).invalid,
                                            'is-valid': validateField(
                                              'repetitions',
                                              i
                                            ).valid
                                          }"
                                        />
                                        <div class="input-group-append">
                                          <span
                                            id="group-repetition"
                                            class="input-group-text font-size-4 font-size-md-5"
                                          >
                                            reps
                                          </span>
                                        </div>
                                      </div>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'required',
                                          message:
                                            'A quantidade de repetições é obrigatória',
                                          control:
                                            exercises.controls[i].controls[
                                              'repetitions'
                                            ]
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'notZero',
                                          message:
                                            'A quantidade de repetições não pode ser zero',
                                          control:
                                            exercises.controls[i].controls[
                                              'repetitions'
                                            ]
                                        }"
                                      ></ng-container>
                                    </ng-template>
                                    <ng-template [ngIf]="!!repMode[i + '-rep']">
                                      <div
                                        id="{{ i }}-duration"
                                        formGroupName="duration"
                                        class="input-group d-flex justify-content-start align-items-center m-0"
                                      >
                                        <div
                                          class="d-flex justify-content-center align-items-center mr-2"
                                        >
                                          <input
                                            id="{{ i }}-durationHour"
                                            type="number"
                                            autocomplete="off"
                                            min="0"
                                            placeholder="00"
                                            formControlName="hour"
                                            (change)="
                                              autoFillTimeFields(
                                                'duration',
                                                'hour',
                                                i
                                              )
                                            "
                                            (keydown.enter)="
                                              $event.preventDefault()
                                            "
                                            class="w-auto form-control reduced-number__input rounded mr-1"
                                            [ngClass]="{
                                              invalid: validateField(
                                                'duration',
                                                i
                                              ).invalid,
                                              valid: validateField(
                                                'duration',
                                                i
                                              ).valid
                                            }"
                                          />
                                          <span
                                            class="d-block text-secondary font-medium-1 text-bold-600"
                                            >:</span
                                          >
                                        </div>
                                        <div
                                          class="d-flex justify-content-center align-items-center mr-2"
                                        >
                                          <input
                                            id="{{ i }}-durationMinute"
                                            type="number"
                                            autocomplete="off"
                                            min="0"
                                            placeholder="00"
                                            formControlName="minute"
                                            (change)="
                                              autoFillTimeFields(
                                                'duration',
                                                'minute',
                                                i
                                              )
                                            "
                                            (keydown.enter)="
                                              $event.preventDefault()
                                            "
                                            class="w-auto form-control reduced-number__input rounded mr-1"
                                            [ngClass]="{
                                              invalid: validateField(
                                                'duration',
                                                i
                                              ).invalid,
                                              valid: validateField(
                                                'duration',
                                                i
                                              ).valid
                                            }"
                                          />
                                          <span
                                            class="d-block text-secondary font-medium-1 text-bold-600"
                                            >:</span
                                          >
                                        </div>
                                        <div
                                          class="d-flex justify-content-center align-items-center"
                                        >
                                          <input
                                            id="{{ i }}-durationSecond"
                                            type="number"
                                            autocomplete="off"
                                            min="0"
                                            placeholder="00"
                                            formControlName="second"
                                            (change)="
                                              autoFillTimeFields(
                                                'duration',
                                                'second',
                                                i
                                              )
                                            "
                                            (keydown.enter)="
                                              $event.preventDefault()
                                            "
                                            class="w-auto form-control reduced-number__input rounded mr-1"
                                            [ngClass]="{
                                              invalid: validateField(
                                                'duration',
                                                i
                                              ).invalid,
                                              valid: validateField(
                                                'duration',
                                                i
                                              ).valid
                                            }"
                                          />
                                        </div>
                                      </div>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'required',
                                          message: 'As horas são obrigatórios',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['hour']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'min',
                                          message:
                                            'As horas devem ser maiores ou iguais a 0',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['hour']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'max',
                                          message:
                                            'As horas devem ser menores que 24',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['hour']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'required',
                                          message:
                                            'Os minutos são obrigatórios',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['minute']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'min',
                                          message:
                                            'Os minutos devem ser maiores ou iguais a 0',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['minute']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'max',
                                          message:
                                            'Os minutos devem ser menores que 60 (60 minutos devem ser definidos como 1 hora)',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['minute']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'required',
                                          message:
                                            'Os segundos são obrigatórios',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['second']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'min',
                                          message:
                                            'Os segundos devem ser maiores que 0',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['second']
                                        }"
                                      ></ng-container>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'max',
                                          message:
                                            'Os segundos devem ser menores que 60 (60 segundos devem ser definidos como 1 minuto)',
                                          control:
                                            exercises.controls[i].controls[
                                              'duration'
                                            ].controls['second']
                                        }"
                                      ></ng-container>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3 pr-md-4"
                            >
                              <div class="form-group">
                                <label
                                  for="breakTime-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                >
                                  Tempo de Descanso
                                </label>
                                <div
                                  id="breakTime-{{ i }}"
                                  formGroupName="breakTime"
                                  class="input-group d-flex justify-content-start align-items-center m-0"
                                >
                                  <div
                                    class="d-flex justify-content-center align-items-center mr-2"
                                  >
                                    <input
                                      id="{{ i }}-breakTimeMinute"
                                      type="number"
                                      autocomplete="off"
                                      min="0"
                                      placeholder="00"
                                      formControlName="minute"
                                      (change)="
                                        autoFillTimeFields(
                                          'breakTime',
                                          'minute',
                                          i
                                        )
                                      "
                                      (keydown.enter)="$event.preventDefault()"
                                      class="w-auto form-control reduced-number__input rounded mr-1"
                                      [ngClass]="{
                                        invalid: validateField('breakTime', i)
                                          .invalid,
                                        valid: validateField('breakTime', i)
                                          .valid
                                      }"
                                    />
                                    <span
                                      class="d-block text-secondary font-medium-1 text-bold-600"
                                      >:</span
                                    >
                                  </div>
                                  <div
                                    class="d-flex justify-content-center align-items-center"
                                  >
                                    <input
                                      id="{{ i }}-breakTimeSecond"
                                      type="number"
                                      autocomplete="off"
                                      min="0"
                                      placeholder="00"
                                      formControlName="second"
                                      (change)="
                                        autoFillTimeFields(
                                          'breakTime',
                                          'second',
                                          i
                                        )
                                      "
                                      (keydown.enter)="$event.preventDefault()"
                                      class="w-auto form-control reduced-number__input rounded mr-1"
                                      [ngClass]="{
                                        invalid: validateField('breakTime', i)
                                          .invalid,
                                        valid: validateField('breakTime', i)
                                          .valid
                                      }"
                                    />
                                  </div>
                                </div>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Os minutos são obrigatórios',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['minute']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'min',
                                    message:
                                      'Os minutos devem ser maiores ou iguais a 0',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['minute']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'max',
                                    message:
                                      'Os minutos devem ser menores que 60',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['minute']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Os segundos são obrigatórios',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['second']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'min',
                                    message:
                                      'Os segundos devem ser maiores que 0',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['second']
                                  }"
                                ></ng-container>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'max',
                                    message:
                                      'Os segundos devem ser menores que 60 (60 segundos devem ser definidos como 1 minuto)',
                                    control:
                                      exercises.controls[i].controls[
                                        'breakTime'
                                      ].controls['second']
                                  }"
                                ></ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-3">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3"
                            >
                              <div class="form-group">
                                <label
                                  for="load-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                >
                                  Carga
                                </label>
                                <div
                                  id="load-{{ i }}"
                                  class="w-100 d-flex justify-content-start align-items-center"
                                >
                                  <div
                                    role="group"
                                    class="d-flex align-items-center position-relative"
                                  >
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 14 14"
                                      fill="currentColor"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="switch__icon mr-2"
                                      [ngClass]="{
                                        grey: !loadMode[i + '-load'],
                                        active: loadMode[i + '-load']
                                      }"
                                    >
                                      <g id="SVGRepo_iconCarrier">
                                        <path
                                          id="Vector"
                                          d="M6.62298 0.583984C5.29029 0.583984 4.1985 1.67577 4.1985 3.00847C4.1985 3.77165 4.55694 4.45535 5.11324 4.90075H2.83842L0 13.416H13.246L10.4075 4.90075H8.13273C8.68903 4.45535 9.04747 3.77165 9.04747 3.00847C9.04747 1.67577 7.95568 0.583984 6.62298 0.583984ZM6.62298 1.64839C7.38043 1.64839 7.98306 2.25102 7.98306 3.00847C7.98306 3.76591 7.38043 4.36855 6.62298 4.36855C5.86554 4.36855 5.26291 3.76591 5.26291 3.00847C5.26291 2.25102 5.86554 1.64839 6.62298 1.64839ZM4.19214 7.64899H4.88696V8.63248L5.88848 7.64896H6.69516L5.39767 8.92478L6.82871 10.3432H5.95891L4.88696 9.28212V10.3432H4.19214V7.64899ZM7.73822 8.27699C7.87896 8.27699 8.0029 8.30461 8.10996 8.35996C8.21699 8.41531 8.3151 8.50247 8.40415 8.62163V8.32211H9.0538V10.1394C9.0538 10.4642 8.9509 10.712 8.74518 10.8828C8.54066 11.0549 8.24349 11.1409 7.85368 11.1409C7.72737 11.1409 7.60531 11.1313 7.48734 11.112C7.36949 11.0928 7.25093 11.0633 7.13183 11.0236V10.5201C7.24495 10.5851 7.35565 10.6332 7.46387 10.6645C7.5722 10.697 7.68109 10.7132 7.79058 10.7132C8.00234 10.7132 8.15751 10.6669 8.25614 10.5743C8.35481 10.4816 8.40415 10.3367 8.40415 10.1394V10.0004C8.31516 10.1183 8.21705 10.2049 8.10996 10.2603C8.00293 10.3155 7.87896 10.3433 7.73822 10.3433C7.49154 10.3433 7.28768 10.2464 7.12648 10.0528C6.96525 9.85785 6.88462 9.61002 6.88462 9.30926C6.88462 9.00727 6.96525 8.76003 7.12648 8.56755C7.28768 8.37388 7.49154 8.27699 7.73822 8.27699ZM7.97824 8.74255C7.84469 8.74255 7.74058 8.79193 7.66602 8.89054C7.59142 8.98923 7.55413 9.12879 7.55413 9.30926C7.55413 9.49453 7.59021 9.63527 7.66241 9.73148C7.73461 9.82654 7.8399 9.87408 7.97824 9.87408C8.11298 9.87408 8.21762 9.8247 8.29224 9.72607C8.36681 9.6274 8.40412 9.48847 8.40412 9.30923C8.40412 9.12876 8.36681 8.9892 8.29221 8.89057C8.21762 8.7919 8.11298 8.74255 7.97821 8.74255H7.97824Z"
                                          fill="currentColor"
                                        />
                                      </g>
                                    </svg>
                                    <ui-switch
                                      class="switchery switchery-warning"
                                      size="small"
                                      id="load-mode-switch-{{ i }}"
                                      [checked]="!loadMode[i + '-load']"
                                      (change)="switchLoadMode(i)"
                                    >
                                    </ui-switch>
                                    <svg
                                      width="25"
                                      height="25"
                                      viewBox="0 0 10 14"
                                      fill="currentColor"
                                      xmlns="http://www.w3.org/2000/svg"
                                      class="switch__icon ml-2"
                                      [ngClass]="{
                                        grey: loadMode[i + '-load'],
                                        active: !loadMode[i + '-load']
                                      }"
                                    >
                                      <g
                                        id="Frame"
                                        clip-path="url(#clip0_621_1227)"
                                      >
                                        <g id="SVGRepo_iconCarrier">
                                          <path
                                            id="Vector"
                                            d="M5.00747 1.74984C5.00758 1.96907 4.94268 2.18341 4.82096 2.36576C4.69925 2.5481 4.52619 2.69025 4.32368 2.77422C4.12117 2.8582 3.8983 2.88023 3.68327 2.83753C3.46823 2.79483 3.27069 2.68932 3.11563 2.53434C2.96057 2.37936 2.85495 2.18187 2.81214 1.96686C2.76933 1.75185 2.79124 1.52897 2.87511 1.32642C2.95898 1.12386 3.10104 0.950729 3.28332 0.828918C3.46559 0.707107 3.6799 0.64209 3.89913 0.64209C4.19298 0.64209 4.4748 0.75878 4.68264 0.966507C4.89047 1.17423 5.00731 1.45599 5.00747 1.74984ZM4.7998 3.50042H2.99847C2.75712 3.50037 2.52267 3.58101 2.33242 3.72951C2.14216 3.87802 2.00702 4.08586 1.94847 4.32001L0.978968 8.20034C0.966042 8.25859 0.966684 8.31902 0.980845 8.37698C0.995005 8.43494 1.02231 8.48887 1.06063 8.53459C1.10717 8.59321 1.16606 8.64086 1.23311 8.67413C1.30016 8.7074 1.37372 8.72548 1.44855 8.72709C1.53047 8.72582 1.61023 8.70055 1.67793 8.65441C1.74564 8.60827 1.79832 8.54329 1.82947 8.46751L2.73247 5.30876V7.58376L2.19463 12.9615C2.18884 13.0191 2.1952 13.0773 2.21329 13.1323C2.23139 13.1873 2.26082 13.2379 2.29968 13.2809C2.33854 13.3238 2.38598 13.3581 2.43892 13.3816C2.49187 13.405 2.54914 13.4171 2.60705 13.4171H2.65022C2.74409 13.4171 2.83501 13.3842 2.90723 13.3242C2.97945 13.2643 3.02844 13.1809 3.04572 13.0887L3.89913 8.50717L4.75255 13.0887C4.76983 13.1809 4.81882 13.2643 4.89104 13.3242C4.96326 13.3842 5.05417 13.4171 5.14805 13.4171H5.19122C5.24913 13.4171 5.3064 13.405 5.35935 13.3816C5.41229 13.3581 5.45972 13.3238 5.49859 13.2809C5.53745 13.2379 5.56688 13.1873 5.58498 13.1323C5.60307 13.0773 5.60943 13.0191 5.60363 12.9615L5.0658 7.58376V5.30876L5.9688 8.46751C6.00003 8.54318 6.05276 8.60804 6.12046 8.65407C6.18816 8.7001 6.26786 8.72529 6.34972 8.72651C6.4245 8.72497 6.49803 8.70698 6.56508 8.67381C6.63212 8.64064 6.69104 8.59311 6.73763 8.53459C6.77596 8.48887 6.80326 8.43494 6.81742 8.37698C6.83158 8.31902 6.83223 8.25859 6.8193 8.20034L5.8498 4.32001C5.79125 4.08586 5.65611 3.87802 5.46585 3.72951C5.27559 3.58101 5.04115 3.50037 4.7998 3.50042Z"
                                            fill="currentColor"
                                          />
                                        </g>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_621_1227">
                                          <rect
                                            width="9"
                                            height="14"
                                            fill="white"
                                            transform="translate(0.899414)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  <div
                                    class="d-flex flex-column align-items-start ml-3"
                                  >
                                    <ng-template [ngIf]="loadMode[i + '-load']">
                                      <div class="input-group m-0">
                                        <input
                                          type="text"
                                          autocomplete="off"
                                          id="load-input-{{ i }}"
                                          formControlName="load"
                                          aria-describedby="group-repetition"
                                          (keydown.enter)="
                                            $event.preventDefault()
                                          "
                                          class="form-control"
                                          [ngClass]="{
                                            'is-invalid': validateField(
                                              'load',
                                              i
                                            ).invalid,
                                            'is-valid': validateField('load', i)
                                              .valid
                                          }"
                                        />
                                        <div class="input-group-append">
                                          <span
                                            id="group-repetition"
                                            class="input-group-text font-size-4 font-size-md-5"
                                          >
                                            kg
                                          </span>
                                        </div>
                                      </div>
                                      <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                          validation: 'notZero',
                                          message:
                                            'A Carga Sugerida não pode ser zero',
                                          control:
                                            exercises.controls[i].controls[
                                              'load'
                                            ]
                                        }"
                                      ></ng-container>
                                    </ng-template>
                                    <ng-template
                                      [ngIf]="!loadMode[i + '-load']"
                                    >
                                      <div class="input-group m-0 py-1">
                                        <span>Peso Corporal</span>
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-5">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3"
                            >
                              <div class="form-group">
                                <label
                                  for="speed-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                  >VELOCIDADE DE EXECUÇÃO</label
                                >
                                <div id="speed-{{ i }}" class="input-group m-0">
                                  <div
                                    class="radio radio-sm d-inline-block mr-3 mb-1"
                                  >
                                    <input
                                      id="isometric-switch-{{ i }}"
                                      type="radio"
                                      formControlName="speed"
                                      value="isometric"
                                    />
                                    <label
                                      for="isometric-switch-{{ i }}"
                                      class="normal-case cursor-pointer font-size-3 font-size-md-4"
                                      >Isométrico</label
                                    >
                                  </div>
                                  <div
                                    class="radio radio-sm d-inline-block mr-3 mb-1"
                                  >
                                    <input
                                      id="slow-switch-{{ i }}"
                                      type="radio"
                                      formControlName="speed"
                                      value="slow"
                                    />
                                    <label
                                      for="slow-switch-{{ i }}"
                                      class="normal-case cursor-pointer font-size-3 font-size-md-4"
                                      >Lento</label
                                    >
                                  </div>
                                  <div
                                    class="radio radio-sm d-inline-block mr-3 mb-1"
                                  >
                                    <input
                                      id="medium-switch-{{ i }}"
                                      type="radio"
                                      formControlName="speed"
                                      value="medium"
                                    />
                                    <label
                                      for="medium-switch-{{ i }}"
                                      class="normal-case cursor-pointer font-size-3 font-size-md-4"
                                      >Moderado</label
                                    >
                                  </div>
                                  <div
                                    class="radio radio-sm d-inline-block mb-1"
                                  >
                                    <input
                                      id="fast-switch-{{ i }}"
                                      type="radio"
                                      formControlName="speed"
                                      value="fast"
                                    />
                                    <label
                                      for="fast-switch-{{ i }}"
                                      class="normal-case cursor-pointer font-size-3 font-size-md-4"
                                      >Rápido</label
                                    >
                                  </div>
                                </div>
                                <ng-container
                                  [ngTemplateOutlet]="formError"
                                  [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message:
                                      'A velocidade de execução é obrigatória',
                                    control:
                                      exercises.controls[i].controls['speed']
                                  }"
                                ></ng-container>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-4">
                            <div
                              class="w-100 d-flex justify-content-start align-items-start py-1 py-md-3 pr-md-4"
                            >
                              <div class="w-100 form-group">
                                <label
                                  for="note-{{ i }}"
                                  class="mb-2 font-size-3 font-size-md-4"
                                  >Observações:
                                  <span class="text-secondary">(opcional)</span>
                                </label>
                                <div class="input-group m-0">
                                  <textarea
                                    id="note-{{ i }}"
                                    rows="3"
                                    autocomplete="off"
                                    class="form-control"
                                    placeholder="Adicione observações sobre o exercício"
                                    formControlName="note"
                                    [ngClass]="{
                                      'is-invalid': validateField('note', i)
                                        .invalid,
                                      'is-valid': validateField('note', i).valid
                                    }"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            class="w-100 d-flex justify-content-start align-items-center mt-2 mt-md-3 px-1 px-md-0"
          >
            <span class="font-size-3 font-size-md-5 black text-bold-400">{{
              "Selecionados (" + chkBoxSelected.length + ")"
            }}</span>
          </div>

          <div
            class="w-100 d-flex flex-column justify-content-center align-items-start mt-2 px-1 px-md-0"
          >
            <button
              *ngIf="chkBoxSelected && chkBoxSelected.length > 0"
              type="button"
              title="Remover exercícios selecionados"
              class="btn btn-sm px-2 text-secondary"
              (click)="removeSelectedExercisesModal()"
            >
              <i class="ft-trash-2"></i>
              <span class="ml-2">Deletar exercícios</span>
            </button>
            <button
              type="button"
              title="Agrupar exercícios"
              disabled
              class="btn btn-sm px-2 text-secondary shadow-none mt-1 position-relative"
              (click)="groupExercises()"
            >
              <i class="ft-copy"></i>
              <span class="ml-2">Agrupar exercícios</span>
              <span
                class="badge badge-primary p-1 position-absolute badge-position font-small-1"
                >Em breve</span
              >
            </button>
          </div>

          <div
            class="w-100 d-flex justify-content-center align-items-start mt-2 px-1 px-md-0"
          >
            <div class="w-100 form-note-block form-group">
              <label
                for="note"
                class="mb-2 font-size-3 font-size-md-4 label-normal"
                >Observações:
              </label>
              <div class="input-group m-0">
                <textarea
                  id="note"
                  rows="3"
                  autocomplete="off"
                  placeholder="Adicione observações sobre o treino"
                  class="form-control"
                  formControlName="note"
                  [ngClass]="{
                    'is-invalid': validateField('note').invalid,
                    'is-valid': validateField('note').valid
                  }"
                ></textarea>
              </div>
            </div>
          </div>

          <!-- <div class="w-100 mt-4 px-1 px-md-0 d-flex justify-content-center">
            <div
              *ngIf="!isLoading && !feedbackResgistered.includes('first')"
              class="card border feedback-container shadow-card"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <div class="w-100 d-flex">
                      <div
                        class="inline-image-container position-relative mr-md-3 mt-auto"
                      >
                        <img
                          src="../../../../../assets/img/iago_inline_feedback.png"
                          alt="I.A.GO - Feedback"
                        />
                      </div>
                      <div
                        class="fields-container w-100 d-flex justify-content-between align-items-start"
                      >
                        <div
                          class="w-100 w-md-auto d-flex align-items-center mr-md-4"
                        >
                          <div
                            class="w-100 d-flex flex-column align-items-start justify-content-center"
                          >
                            <span class="main-label font-size-5"
                              >O que está achando dessa experiência?</span
                            >
                            <div
                              id="feedback-inputs"
                              class="w-100 position-relative d-flex justify-content-between justify-content-lg-start align-items-center mt-2 mt-md-3"
                            >
                              <div class="d-inline-block mr-4">
                                <input
                                  id="fd-negatve"
                                  type="radio"
                                  name="feedback"
                                  [checked]="initialFeedback === 'negative'"
                                  (click)="setInitialFeedback('negative')"
                                  class="hidden-input"
                                />
                                <label
                                  for="fd-negatve"
                                  class="d-flex justify-content-center align-items-center cursor-pointer"
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 57 58"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    [ngClass]="{
                                      'feedback-icon__disabled':
                                        initialFeedback &&
                                        initialFeedback !== 'negative'
                                    }"
                                  >
                                    <path
                                      d="M28.3459 3.61279C23.3626 3.61279 18.4911 5.09053 14.3476 7.85913C10.2041 10.6277 6.97467 14.5628 5.06762 19.1669C3.16058 23.7709 2.66161 28.837 3.63381 33.7246C4.60601 38.6122 7.00572 43.1017 10.5295 46.6255C14.0532 50.1493 18.5428 52.549 23.4304 53.5212C28.318 54.4934 33.3841 53.9944 37.9881 52.0874C42.5921 50.1803 46.5273 46.9509 49.2959 42.8074C52.0645 38.6638 53.5422 33.7924 53.5422 28.8091C53.5422 22.1266 50.8876 15.7178 46.1624 10.9926C41.4372 6.26739 35.0284 3.61279 28.3459 3.61279ZM28.3459 50.8558C23.9855 50.8558 19.723 49.5628 16.0974 47.1402C12.4719 44.7177 9.64607 41.2745 7.97741 37.246C6.30875 33.2175 5.87215 28.7846 6.72282 24.508C7.5735 20.2313 9.67325 16.303 12.7565 13.2197C15.8398 10.1364 19.7682 8.03663 24.0448 7.18595C28.3215 6.33527 32.7543 6.77187 36.7829 8.44053C40.8114 10.1092 44.2546 12.935 46.6771 16.5605C49.0996 20.1861 50.3927 24.4486 50.3927 28.8091C50.3927 34.6562 48.0699 40.2639 43.9353 44.3984C39.8008 48.533 34.1931 50.8558 28.3459 50.8558Z"
                                      fill="#F03D3D"
                                    />
                                    <path
                                      d="M39.6212 25.7854C41.1867 25.7854 42.4558 24.5163 42.4558 22.9508C42.4558 21.3853 41.1867 20.1162 39.6212 20.1162C38.0557 20.1162 36.7866 21.3853 36.7866 22.9508C36.7866 24.5163 38.0557 25.7854 39.6212 25.7854Z"
                                      fill="#F03D3D"
                                    />
                                    <path
                                      d="M17.9681 25.7854C19.5336 25.7854 20.8027 24.5163 20.8027 22.9508C20.8027 21.3853 19.5336 20.1162 17.9681 20.1162C16.4026 20.1162 15.1335 21.3853 15.1335 22.9508C15.1335 24.5163 16.4026 25.7854 17.9681 25.7854Z"
                                      fill="#F03D3D"
                                    />
                                    <path
                                      d="M28.5978 31.9585C26.3386 31.9589 24.1122 32.4993 22.1043 33.5348C20.0964 34.5703 18.3651 36.0707 17.0548 37.9111C16.8125 38.2515 16.7154 38.6742 16.7848 39.0862C16.8542 39.4981 17.0845 39.8657 17.4248 40.1079C17.7652 40.3502 18.1879 40.4473 18.5999 40.3779C19.0119 40.3084 19.3794 40.0782 19.6216 39.7378C20.6285 38.3236 21.9553 37.1671 23.4937 36.3627C25.0322 35.5582 26.7389 35.1285 28.4749 35.1085C30.2109 35.0886 31.927 35.4789 33.4836 36.2478C35.0402 37.0167 36.3931 38.1424 37.4322 39.5331C37.6828 39.8672 38.0559 40.0881 38.4694 40.1472C38.8828 40.2063 39.3028 40.0987 39.6369 39.8481C39.971 39.5975 40.1919 39.2244 40.251 38.811C40.3101 38.3975 40.2025 37.9775 39.9519 37.6434C38.6318 35.8782 36.9181 34.4452 34.9471 33.4583C32.9761 32.4714 30.8021 31.9579 28.5978 31.9585Z"
                                      fill="#F03D3D"
                                    />
                                  </svg>

                                  <span
                                    class="text-capitalize ml-2 font-size-4 font-size-md-5"
                                  >
                                    Ruim
                                  </span>
                                </label>
                              </div>
                              <div class="d-inline-block mr-4">
                                <input
                                  id="fd-neutral"
                                  type="radio"
                                  name="feedback"
                                  [checked]="initialFeedback === 'neutral'"
                                  (click)="setInitialFeedback('neutral')"
                                  class="hidden-input"
                                />
                                <label
                                  for="fd-neutral"
                                  class="d-flex justify-content-center align-items-center cursor-pointer"
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 57 58"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    [ngClass]="{
                                      'feedback-icon__disabled':
                                        initialFeedback &&
                                        initialFeedback !== 'neutral'
                                    }"
                                  >
                                    <path
                                      d="M37.9715 35.2026H19.0743C18.6566 35.2026 18.2561 35.3686 17.9608 35.6639C17.6654 35.9592 17.4995 36.3597 17.4995 36.7774C17.4995 37.1951 17.6654 37.5956 17.9608 37.8909C18.2561 38.1863 18.6566 38.3522 19.0743 38.3522H37.9715C38.3891 38.3522 38.7897 38.1863 39.085 37.8909C39.3803 37.5956 39.5462 37.1951 39.5462 36.7774C39.5462 36.3597 39.3803 35.9592 39.085 35.6639C38.7897 35.3686 38.3891 35.2026 37.9715 35.2026Z"
                                      fill="#ECA317"
                                    />
                                    <path
                                      d="M28.4446 3.61279C23.4612 3.61279 18.5898 5.09053 14.4463 7.85913C10.3028 10.6277 7.0733 14.5628 5.16625 19.1669C3.25921 23.7709 2.76024 28.837 3.73244 33.7246C4.70464 38.6122 7.10436 43.1017 10.6281 46.6255C14.1519 50.1493 18.6414 52.549 23.529 53.5212C28.4166 54.4934 33.4827 53.9944 38.0868 52.0874C42.6908 50.1803 46.6259 46.9509 49.3945 42.8074C52.1631 38.6638 53.6408 33.7924 53.6408 28.8091C53.6408 22.1266 50.9862 15.7178 46.261 10.9926C41.5358 6.26739 35.127 3.61279 28.4446 3.61279ZM28.4446 50.8558C24.0841 50.8558 19.8216 49.5628 16.1961 47.1402C12.5705 44.7177 9.74471 41.2745 8.07604 37.246C6.40738 33.2175 5.97078 28.7846 6.82146 24.508C7.67213 20.2313 9.77188 16.303 12.8552 13.2197C15.9385 10.1364 19.8668 8.03663 24.1435 7.18595C28.4201 6.33527 32.853 6.77187 36.8815 8.44053C40.91 10.1092 44.3532 12.935 46.7758 16.5605C49.1983 20.1861 50.4913 24.4486 50.4913 28.8091C50.4913 34.6562 48.1685 40.2639 44.034 44.3984C39.8994 48.533 34.2917 50.8558 28.4446 50.8558Z"
                                      fill="#ECA317"
                                    />
                                    <path
                                      d="M39.7196 25.7854C41.2851 25.7854 42.5542 24.5163 42.5542 22.9508C42.5542 21.3853 41.2851 20.1162 39.7196 20.1162C38.1541 20.1162 36.885 21.3853 36.885 22.9508C36.885 24.5163 38.1541 25.7854 39.7196 25.7854Z"
                                      fill="#ECA317"
                                    />
                                    <path
                                      d="M17.673 25.7854C19.2385 25.7854 20.5075 24.5163 20.5075 22.9508C20.5075 21.3853 19.2385 20.1162 17.673 20.1162C16.1075 20.1162 14.8384 21.3853 14.8384 22.9508C14.8384 24.5163 16.1075 25.7854 17.673 25.7854Z"
                                      fill="#ECA317"
                                    />
                                  </svg>

                                  <span
                                    class="text-capitalize ml-2 font-size-4 font-size-md-5"
                                  >
                                    Média
                                  </span>
                                </label>
                              </div>
                              <div class="d-inline-block">
                                <input
                                  id="fd-positive"
                                  type="radio"
                                  name="feedback"
                                  [checked]="initialFeedback === 'positive'"
                                  (click)="setInitialFeedback('positive')"
                                  class="hidden-input"
                                />
                                <label
                                  for="fd-positive"
                                  class="d-flex justify-content-center align-items-center cursor-pointer"
                                >
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 58 58"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    [ngClass]="{
                                      'feedback-icon__disabled':
                                        initialFeedback &&
                                        initialFeedback !== 'positive'
                                    }"
                                  >
                                    <path
                                      d="M17.3558 34.2368C19.3018 38.6628 24.1259 41.7924 29.1937 41.7924C34.24 41.7924 39.0548 38.6547 41.0176 34.2479"
                                      stroke="#1EC02E"
                                      stroke-width="3.14953"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <circle
                                      cx="21.6364"
                                      cy="21.6362"
                                      r="2.5195"
                                      fill="#1EC02E"
                                    />
                                    <circle
                                      cx="36.7535"
                                      cy="21.6362"
                                      r="2.5195"
                                      fill="#1EC02E"
                                    />
                                    <path
                                      d="M29.195 54.39C43.1098 54.39 54.39 43.1098 54.39 29.195C54.39 15.2802 43.1098 4 29.195 4C15.2802 4 4 15.2802 4 29.195C4 43.1098 15.2802 54.39 29.195 54.39Z"
                                      stroke="#1EC02E"
                                      stroke-width="3.14953"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>

                                  <span
                                    class="text-capitalize ml-2 font-size-4 font-size-md-5"
                                  >
                                    Boa
                                  </span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="w-100 w-md-auto d-flex flex-column align-items-end justify-content-start text-input-container"
                        >
                          <div class="input-group w-100 m-0">
                            <textarea
                              id="notes"
                              name="notes"
                              rows="3"
                              placeholder="Deixe seu comentário"
                              [(ngModel)]="initialFeedbackNotes"
                              [ngModelOptions]="{ standalone: true }"
                              class="form-control w-100 font-size-4 font-size-md-5"
                            ></textarea>
                          </div>
                          <button
                            type="button"
                            title="Enviar"
                            (click)="sendInitialFeedback()"
                            class="btn btn-sm text-primary shadow-none mt-1"
                          >
                            Enviar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <span
            *ngIf="!isLoading && feedbackResgistered.includes('first')"
            class="mt-4 px-1 px-md-0"
            >Obrigado pelo feedback!</span
          > -->

          <div
            class="w-100 d-flex justify-content-between align-items-center mt-4 px-1 px-md-0"
          >
            <button
              type="button"
              title="Voltar"
              class="btn px-4 text-secondary"
              (click)="navigateBack()"
            >
              Voltar
            </button>
            <button
              type="submit"
              title="Enviar"
              class="btn btn-primary px-4 white"
            >
              Enviar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="
      control &&
      control.hasError(validation) &&
      (control.dirty || control.touched)
    "
  >
    <div class="mt-2">
      <span role="alert" class="font-small-3 text-danger text-bold-600">
        {{ message }}
      </span>
    </div>
  </ng-container>
</ng-template>
